var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayExtraLightItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:27:49 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-ExtraLightItalic",
    horizAdvX: 585
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway ExtraLight",
    fontWeight: 275,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 3 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 520,
    capHeight: 709,
    bbox: "-271 -224 1336 938",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 532,
    d: "M136 490h-70l6 30h71l2 9q6 31 20.5 61.5t37 55t52.5 39.5t69 15q33 0 57 -8.5t35 -17.5q26 30 58.5 48t77.5 18q24 0 39 -4.5t24 -10t12.5 -11t5.5 -8.5l-21 -22q-2 3 -6 7t-10.5 8t-17.5 6.5t-27 2.5q-37 0 -65.5 -15.5t-49 -40t-33 -54.5t-18.5 -59l-4 -19h169l-6 -30 h-170l-104 -490h-34l104 490h-170l-104 -490h-34zM346 520q8 43 20.5 72t30.5 54q-14 14 -37 18.5t-38 4.5q-34 0 -58.5 -14t-41.5 -35t-27.5 -45.5t-15.5 -45.5l-2 -9h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 446,
    d: "M136 490h-70l6 30h71l4 19q6 33 22 68.5t41.5 65t60.5 48.5t80 19q25 0 45.5 -5t35 -11.5t23.5 -12.5t11 -9l-25 -23q-8 11 -34 20t-62 9q-35 0 -62.5 -15.5t-48 -40t-34 -54.5t-19.5 -59l-4 -19h237l-110 -520h-34l104 490h-204l-104 -490h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 516,
    d: "M380 -5q-33 0 -49.5 18.5t-16.5 45.5q0 6 0.5 12t2.5 14l110 516q3 12 3 27q0 16 -5 30.5t-16 25.5t-29 17.5t-44 6.5q-32 0 -58 -15t-45.5 -39t-32.5 -54.5t-19 -61.5l-4 -18h114l-7 -30h-114l-104 -490h-34l104 490h-70l6 30h71l4 20q9 42 25.5 78.5t41 63.5t56.5 42.5 t73 15.5q61 0 91.5 -29t30.5 -74q0 -17 -4 -32l-109 -516q-2 -10 -2 -15q0 -18 10.5 -33t33.5 -15q19 0 39 5t21 5l3 -30q0 -1 -7 -2.5t-18 -3.5t-25 -3.5t-27 -1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 650,
    d: "M136 490h-70l6 30h71l1 8q6 31 20.5 61.5t37 55t53.5 40t70 15.5q32 0 56 -8.5t35 -17.5q26 30 60.5 48t79.5 18q24 0 44 -5t34.5 -11.5t23.5 -12.5t12 -9l-25 -23q-8 11 -34.5 20t-57.5 9q-37 0 -66 -15.5t-49.5 -40t-33.5 -54.5t-19 -59l-4 -19h238l-111 -520h-34 l104 490h-204l-104 -490h-34l104 490h-170l-104 -490h-34zM346 520q9 38 21 69.5t30 56.5q-14 14 -37 18.5t-38 4.5q-34 0 -59 -14t-42.5 -35t-28 -45.5t-14.5 -45.5l-1 -9h169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 724,
    d: "M592 -5q-37 0 -53.5 18t-16.5 46q0 6 0.5 12.5t2.5 14.5l110 515q3 12 3 26q0 34 -21.5 57.5t-67.5 23.5q-35 0 -62 -15t-46.5 -39t-32.5 -55t-19 -62l-3 -17h113l-7 -30h-113l-104 -490h-34l104 490h-175l-104 -490h-34l104 490h-70l6 30h71l1 8q8 36 24.5 67.5t40 54.5 t54 36.5t68.5 13.5q35 0 54 -8.5t30 -16.5q25 30 58.5 47.5t78.5 17.5q60 0 90.5 -29.5t30.5 -74.5q0 -15 -3 -31l-110 -516q-2 -10 -2 -16q0 -17 10.5 -32t35.5 -15q8 0 17.5 1.5t18.5 3.5t15 3.5t7 1.5l3 -30q-1 -1 -8 -2.5t-18 -3.5t-23.5 -3.5t-23.5 -1.5zM351 520 q9 42 20 73t25 54q-13 14 -31.5 18t-35.5 4q-33 0 -58.5 -12.5t-44.5 -32.5t-30.5 -45.5t-17.5 -50.5l-1 -8h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 253
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 231,
    d: "M79 208l108 509h33l-107 -509h-34zM35 0l19 92h38l-24 -92h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 234,
    d: "M123 556l33 156h31l-33 -156h-31zM184 556l33 156h32l-34 -156h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 631,
    d: "M630 474h-115l-100 -227h128l-6 -30h-136l-95 -217h-32l97 217h-213l-95 -217h-32l97 217h-107l6 30h115l99 227h-127l7 29h134l92 207h31l-93 -207h213l91 207h32l-93 -207h108zM384 247l100 227h-212l-100 -227h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 590,
    d: "M557 605q-28 42 -67.5 59.5t-98.5 18.5l-67 -313q46 -11 83.5 -23.5t64.5 -30.5t41.5 -43t14.5 -61q0 -52 -20.5 -92t-58 -68t-89.5 -42.5t-114 -14.5l-19 -91h-25l20 92q-140 6 -219 107l26 25q67 -96 200 -103l68 316q-44 10 -79 21.5t-59 28t-36.5 39.5t-12.5 56 q0 51 19.5 92.5t54.5 70.5t83.5 46t106.5 19l22 101h25l-22 -100q63 -1 107.5 -21t74.5 -63zM490 203q0 55 -44 84t-129 50l-67 -312q55 0 99.5 11.5t75.5 34t48 55.5t17 77zM147 496q0 -26 9.5 -44.5t29 -32.5t49 -24t69.5 -20l65 307q-59 -2 -101 -17.5t-69 -40 t-39.5 -57.5t-12.5 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 657,
    d: "M210 441q-48 0 -78 33t-30 81q0 33 14.5 63t38 52.5t53.5 36t62 13.5q48 0 78 -33.5t30 -81.5q0 -33 -14.5 -63t-38 -52.5t-53.5 -35.5t-62 -13zM216 466q25 0 49 11.5t42.5 30t30 43t11.5 50.5q0 40 -24.5 66.5t-60.5 26.5q-25 0 -49 -11t-42.5 -30t-29.5 -43t-11 -50 q0 -40 23 -67t61 -27zM410 -10q-48 0 -78 33t-30 82q0 33 14.5 62.5t38 52t53.5 36t62 13.5q48 0 77.5 -33t29.5 -81q0 -33 -14 -63t-37.5 -52.5t-53.5 -36t-62 -13.5zM415 16q25 0 49 11t42.5 29.5t30 42.5t11.5 50q0 40 -24 67.5t-60 27.5q-25 0 -49 -11.5t-42.5 -30.5 t-30 -43.5t-11.5 -50.5q0 -39 23 -65.5t61 -26.5zM-7 16l676 696l17 -17l-676 -697z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 669,
    d: "M420 115q-51 -59 -110.5 -92t-122.5 -33q-37 0 -68 12t-53 34t-34.5 52.5t-12.5 67.5q0 72 48.5 132t151.5 119q-32 51 -45.5 83t-13.5 60q0 34 16.5 64.5t44 53.5t63.5 37t75 14q54 0 96 -27.5t63 -77.5l-23 -21q-19 45 -56 71.5t-85 26.5q-32 0 -61 -11.5t-51 -30.5 t-35.5 -43.5t-13.5 -51.5q0 -26 14.5 -58.5t47.5 -80.5l170 -244q35 51 60.5 112.5t38.5 132.5h131l-6 -30h-98q-16 -70 -43.5 -131t-64.5 -110l102 -145h-46zM193 21q57 0 110.5 31.5t98.5 88.5l-166 242q-93 -54 -137 -107.5t-44 -116.5q0 -62 38.5 -100t99.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 172,
    d: "M123 555l33 157h31l-33 -157h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 238,
    d: "M48 257q0 67 17.5 127.5t47.5 118t70.5 113.5t85.5 114l23 -16q-34 -39 -71 -92t-68 -112.5t-51.5 -122t-20.5 -122.5q0 -31 3.5 -66.5t10.5 -72t17.5 -72t24.5 -67.5l-29 -16q-29 67 -44.5 142.5t-15.5 143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 238,
    d: "M210 433q0 -60 -15.5 -117.5t-44 -114.5t-69 -114t-91.5 -116l-22 16q46 54 84.5 108.5t66 110t42.5 110t15 108.5q0 37 -4.5 77.5t-12 79.5t-17 73t-20.5 60l30 16q25 -69 41.5 -145.5t16.5 -151.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 299,
    d: "M141 559l52 58l-59 22l12 24l60 -23l14 71h26l-16 -71l71 23v-24l-68 -22l28 -58l-24 -15l-27 59l-52 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 411,
    d: "M367 370v-30h-135v-146h-33v146h-135v30h135v146h33v-146h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 247,
    d: "M24 -81l28 75h-13l17 80h36l-17 -80l-31 -75h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 404,
    d: "M57 255l6 33h272l-7 -33h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 167,
    d: "M6 0l16 74h31l-16 -74h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 551,
    d: "M603 710l-589 -710h-40l589 710h40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 588,
    d: "M228 -10q-42 0 -75 17t-56.5 47.5t-36 73t-12.5 92.5q0 78 25.5 146.5t68 119.5t98.5 81t117 30q42 0 75 -17t56.5 -48t36 -73t12.5 -93q0 -78 -25.5 -146.5t-68.5 -119.5t-98.5 -80.5t-116.5 -29.5zM235 23q54 0 102.5 26.5t85.5 72.5t58.5 108t21.5 134 q0 45 -10.5 81.5t-30 63t-48 41t-64.5 14.5q-54 0 -103 -26.5t-85.5 -73t-58 -108.5t-21.5 -134q0 -45 10.5 -81.5t30 -62.5t48 -40.5t64.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 370,
    d: "M9 32h135l104 492q-10 -12 -31 -26.5t-46.5 -27t-51.5 -21.5t-45 -9l8 36q25 0 55 14t56.5 31t44.5 32.5t20 17.5h35l-115 -539h121l-6 -32h-291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 485,
    d: "M-10 0q5 23 16.5 57.5t35.5 71.5t63.5 72.5t100.5 61.5q55 23 95 42t66.5 39.5t39.5 45t13 57.5q0 19 -7 37t-21.5 32.5t-37.5 23.5t-55 9q-34 0 -63.5 -11t-52.5 -25.5t-39 -29t-22 -20.5l-19 23q2 2 18.5 17t44 32.5t64.5 31.5t79 14q37 0 65 -10.5t46.5 -28 t27.5 -40.5t9 -48q0 -40 -14 -69t-42.5 -52.5t-71 -44.5t-98.5 -45q-47 -20 -82 -49.5t-59 -60t-37.5 -58t-17.5 -43.5h345l-8 -32h-382v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 496,
    d: "M147 -147q-71 0 -117.5 33.5t-57.5 90.5l31 18q7 -50 47 -80t105 -30q46 0 85 15t67 41.5t44 64t16 82.5q0 61 -38 97t-110 36h-22l6 31h23q94 0 147 46t53 122q0 57 -36 90.5t-96 33.5q-58 0 -108 -29.5t-81 -78.5l-21 17q16 28 40 50.5t52.5 38.5t61 25t65.5 9 q36 0 65.5 -11t50.5 -30.5t32 -47t11 -59.5q0 -37 -13 -69.5t-36 -58t-55 -42.5t-69 -22q54 -8 83 -48.5t29 -98.5q0 -51 -20 -94.5t-54.5 -75t-80.5 -49t-99 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 507,
    d: "M310 66h-337l6 29l449 476h23l-101 -473h84l-6 -32h-84l-41 -193h-34zM318 98l89 416l-387 -416h298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 523,
    d: "M158 -149q-72 0 -120.5 39.5t-62.5 103.5l30 10q14 -54 57 -87.5t103 -33.5q46 0 89.5 18t77 50t53.5 75t20 94q0 34 -11 63t-31 49.5t-48 32t-61 11.5q-51 0 -101.5 -24t-89.5 -69h-35q3 8 12 29t20.5 49.5t25.5 62.5t28 69q33 80 71 178h322l-7 -33h-295l-122 -304 q39 35 85.5 54.5t94.5 19.5q39 0 71.5 -13.5t56 -37.5t36.5 -57.5t13 -73.5q0 -60 -24.5 -110.5t-64 -87t-90.5 -57t-103 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 583,
    d: "M237 -10q-42 0 -77 15t-59.5 42.5t-38 67.5t-13.5 90q0 98 25 190t70.5 163t109.5 114t141 43q69 0 113.5 -38.5t52.5 -104.5l-29 -16q-7 57 -46 92t-98 35q-52 0 -99 -26.5t-85.5 -74.5t-67 -115t-43.5 -148q18 36 45.5 65t60.5 49t70.5 31t75.5 11q42 0 76 -15.5 t58 -42.5t37.5 -63t13.5 -78q0 -58 -25 -110t-66 -91t-93.5 -62t-108.5 -23zM245 22q47 0 92 20t80 54t56.5 78.5t21.5 94.5q0 36 -12 68t-33 56t-50.5 37.5t-65.5 13.5q-47 0 -92 -20.5t-80.5 -54.5t-57 -79t-21.5 -94q0 -36 12 -68t33.5 -55.5t51 -37t65.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 511,
    d: "M483 550h-391l7 33h447l-496 -710h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 561,
    d: "M212 -7q-45 0 -79.5 13.5t-58.5 36.5t-36.5 53.5t-12.5 64.5q0 43 18 79t45.5 64t62 47.5t67.5 29.5q-40 17 -67.5 50t-27.5 81q0 47 22.5 84t58 62.5t79 38.5t85.5 13q33 0 64 -9.5t54.5 -28t38 -45.5t14.5 -61q0 -35 -14 -64t-37 -52t-52 -40.5t-60 -28.5 q50 -17 82 -59t32 -99q0 -52 -24 -94.5t-63 -72.5t-89 -46.5t-102 -16.5zM222 23q39 0 80.5 14t75.5 40t56 62.5t22 81.5q0 34 -14 61t-37.5 45.5t-52.5 28t-59 9.5q-39 0 -80.5 -14.5t-75 -41t-55.5 -63t-22 -80.5q0 -34 14 -60.5t37 -45t52 -28t59 -9.5zM300 395 q32 0 68 11t66 32.5t50 52t20 69.5q0 28 -11.5 50t-31.5 37t-46.5 23t-55.5 8q-36 0 -72.5 -11.5t-65 -33t-46.5 -52t-18 -67.5q0 -29 12.5 -51t32.5 -37t46 -23t52 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 567,
    d: "M173 -156q-69 0 -113.5 38.5t-53.5 104.5l30 17q6 -58 45 -93t99 -35q52 0 98.5 26.5t85 74.5t67 115t44.5 149q-18 -36 -45.5 -65t-61 -49.5t-71 -31t-75.5 -10.5q-41 0 -75 15.5t-58 42t-37.5 62.5t-13.5 78q0 58 24.5 110t65.5 91t93.5 62t108.5 23q43 0 77.5 -15 t59.5 -42.5t38.5 -67.5t13.5 -89q0 -98 -25 -190t-71 -163.5t-109.5 -114.5t-140.5 -43zM233 115q47 0 92.5 20.5t81 55t57 79t21.5 93.5q0 36 -12 68t-33.5 56t-51.5 37.5t-66 13.5q-47 0 -92 -20t-80 -54t-56.5 -79t-21.5 -95q0 -36 12 -68t33.5 -55.5t51 -37.5t64.5 -14z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 164,
    d: "M96 443l16 74h31l-16 -74h-31zM2 0l16 74h30l-15 -74h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 169,
    d: "M99 443l15 74h31l-16 -74h-30zM-13 -81l28 75h-13l17 80h37l-18 -80l-31 -75h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 542,
    d: "M31 270l417 250v-37l-368 -224l368 -225v-37l-417 250v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 458,
    d: "M75 220v29h296v-29h-296zM75 303v29h296v-29h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 542,
    d: "M493 247l-417 -250v37l368 225l-368 224v37l417 -250v-23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 452,
    d: "M137 186q9 43 21 73t27 51t32.5 34t38.5 24q28 14 59 27.5t57.5 34.5t43.5 53.5t17 84.5q0 31 -9.5 53.5t-26 37.5t-38.5 22t-46 7q-55 0 -108 -30.5t-88 -81.5l-23 14q20 31 46.5 55t56 40.5t61 25t61.5 8.5t56.5 -9.5t47 -28t32 -46.5t11.5 -64q0 -56 -17 -91 t-44 -58.5t-60.5 -40t-66.5 -33.5q-18 -9 -34 -20t-30 -28.5t-25.5 -44.5t-20.5 -69h-31zM98 0l19 91h31l-19 -91h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 794,
    d: "M546 9q32 0 61 26.5t51.5 68t35.5 93.5t13 103q0 60 -19 111.5t-53 88.5t-82 58t-106 21q-75 0 -146.5 -34.5t-127 -93t-89.5 -134.5t-34 -158q0 -60 19 -111.5t53 -89t81.5 -59t104.5 -21.5q38 0 74.5 9.5t74.5 28.5l6 -22q-42 -20 -84.5 -30t-80.5 -10q-59 0 -109 23 t-86 64t-56.5 96.5t-20.5 120.5q0 88 37 169t97 142t136.5 97.5t155.5 36.5q61 0 112.5 -22t88.5 -62t57.5 -94.5t20.5 -119.5q0 -54 -14.5 -111t-40.5 -103.5t-62 -76.5t-79 -30q-27 0 -40.5 14.5t-13.5 46.5q0 8 0.5 17.5t2.5 19.5q-34 -33 -78 -53t-86 -20 q-33 0 -59.5 13t-45.5 36t-29.5 55.5t-10.5 70.5q0 53 19.5 101.5t52.5 85t76 58.5t90 22q48 0 81.5 -23.5t49.5 -65.5l18 88h28l-75 -351q-5 -20 -6 -31t-1 -17q0 -42 38 -42zM330 35q25 0 51 8.5t49 23.5t41 35t27 42l37 183q-14 47 -47 72t-78 25q-40 0 -77 -19 t-66 -51.5t-46.5 -75t-17.5 -89.5q0 -33 9 -61.5t26 -49t40 -32t52 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 632,
    d: "M181 710h307q30 0 52.5 -12.5t37.5 -32.5t22.5 -46t7.5 -54q0 -32 -10.5 -63t-28.5 -57t-43 -47t-55 -34q45 -15 68.5 -55t23.5 -90q0 -44 -19 -84t-49.5 -70t-70 -47.5t-79.5 -17.5h-315zM351 32q34 0 65.5 16t56.5 42t40 59t15 68q0 25 -7 48t-20.5 40t-33 27.5 t-43.5 10.5h-287l-66 -311h280zM404 374q33 0 63.5 16t54 42t37.5 58.5t14 66.5q0 25 -6.5 47t-19 38.5t-31 26t-41.5 9.5h-266l-65 -304h260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 661,
    d: "M295 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 73 30 147.5t84 135.5t127.5 99.5t160.5 38.5q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42t-55.5 23t-61 7q-78 0 -143.5 -35.5t-113 -91.5t-74.5 -124.5t-27 -135.5q0 -54 15.5 -102.5 t44.5 -85t69.5 -58t91.5 -21.5q32 0 67 8.5t70 26t67.5 44.5t59.5 65l28 -12q-26 -40 -61.5 -71t-76.5 -52t-83.5 -31.5t-81.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 686,
    d: "M181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 583,
    d: "M181 710h437l-7 -32h-402l-63 -300h341l-6 -31h-343l-73 -347h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 688,
    d: "M559 116q-125 -121 -259 -121q-60 0 -106 25t-78 66.5t-48.5 95t-16.5 110.5q0 78 32.5 154t87 135.5t125.5 96.5t148 37q51 0 89.5 -11.5t65.5 -32t44 -49t26 -62.5l-33 -15q-21 73 -72.5 105t-127.5 32q-72 0 -136 -35t-112 -90.5t-75.5 -125t-27.5 -137.5 q0 -54 16 -102.5t45 -84.5t70 -57.5t92 -21.5q64 0 127.5 31t132.5 98l33 154h-155l6 30h187l-73 -341h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 703,
    d: "M181 710h35l-71 -331h446l71 331h34l-151 -710h-34l74 347h-447l-73 -347h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 461,
    d: "M104 -11q-85 0 -137 44l18 28q44 -39 125 -39q58 0 96.5 22t65.5 64t45 103t35 138l77 360h34l-77 -360q-17 -81 -37.5 -147.5t-52 -113.5t-77.5 -73t-115 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 598,
    d: "M181 709h35l-95 -446l505 447h43l-350 -311l212 -399h-41l-199 378l-179 -158l-47 -220h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 553,
    d: "M181 710h35l-145 -678h413l-7 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 844,
    d: "M181 710h33l183 -529l408 529h32l-151 -710h-34l136 642l-389 -504h-23l-174 504l-137 -642h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 742,
    d: "M181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 725,
    d: "M297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5 t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 596,
    d: "M181 710h277q36 0 64 -15t47.5 -40t29.5 -57.5t10 -66.5q0 -47 -19 -92.5t-51.5 -82.5t-76 -59.5t-91.5 -22.5h-248l-58 -274h-35zM377 306q41 0 77 20t63 52t42.5 71t15.5 78q0 30 -9 57.5t-25.5 48.5t-40 33t-51.5 12h-240l-79 -372h247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 724,
    d: "M508 68q-48 -35 -101 -54t-109 -19q-59 0 -105.5 24t-78 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128.5 96t149.5 36q59 0 105 -25t77 -66t47 -94t16 -109q0 -48 -12 -94.5t-33.5 -89t-51.5 -80.5t-66 -68l51 -89h-38zM305 28q51 0 98.5 17.5t89.5 49.5l-56 100h38 l44 -79q33 29 59.5 64.5t45 74.5t29 80.5t10.5 82.5q0 53 -15 101t-43.5 84t-68.5 57.5t-91 21.5q-72 0 -137.5 -35t-115 -90.5t-78.5 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 619,
    d: "M30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78q0 30 -9 57.5t-25.5 48.5t-39.5 33.5t-51 12.5h-242 l-79 -372h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 581,
    d: "M239 -5q-158 0 -242 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5q0 54 21 96.5t59 72t89.5 45t113.5 15.5q66 0 111.5 -20t76.5 -64l-24 -26q-28 43 -68.5 60.5 t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -52 -20.5 -92.5t-58 -68t-89 -42t-114.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 576,
    d: "M348 678h-252l6 32h539l-6 -32h-253l-144 -678h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 723,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 645,
    d: "M100 710h36l129 -667l410 667h37l-440 -710h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 989,
    d: "M99 710h38l128 -669l229 370l-58 293h35l49 -262l161 262h35l-183 -293l74 -370l411 669h38l-442 -710h-33l-74 378l-235 -378h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 593,
    d: "M287 350l-192 360h41l177 -334l318 334h41l-345 -360l186 -350h-41l-170 324l-309 -324h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 598,
    d: "M271 274l-176 436h39l162 -403l334 403h38l-363 -438l-58 -272h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 590,
    d: "M-33 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 226,
    d: "M20 -40l166 780h82l-7 -31h-49l-153 -718h50l-6 -31h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 496,
    d: "M146 710l262 -710h-40l-263 710h41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 225,
    d: "M-21 -40l6 31h49l153 718h-49l7 31h81l-165 -780h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 515,
    d: "M54 303l198 407h30l197 -407h-34l-178 368l-181 -368h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 507,
    d: "M-5 -32l7 32h370l-7 -32h-370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 196,
    d: "M58 730h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 581,
    d: "M238 -10q-33 0 -60 9.5t-48 25.5t-36.5 37t-24.5 44l-23 -106h-31l155 730h34l-70 -328q48 56 104 91t119 35q45 0 78.5 -18.5t55.5 -48.5t33 -68.5t11 -78.5q0 -63 -25.5 -121.5t-67.5 -103.5t-95.5 -72t-108.5 -27zM239 22q50 0 97 24.5t83.5 65t58.5 92.5t22 106 q0 36 -10.5 70t-30.5 59.5t-49.5 41t-67.5 15.5q-32 0 -61.5 -11t-56.5 -30t-52 -44t-48 -52l-43 -210q4 -29 18 -52.5t35 -40t48 -25.5t57 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 517,
    d: "M220 -10q-43 0 -78.5 17t-60.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101.5t97 69t115 25.5q66 0 109 -31.5t57 -86.5l-36 -12q-14 46 -51 72t-88 26q-50 0 -96.5 -22.5t-83 -61t-58.5 -89.5t-22 -108q0 -40 11.5 -75t32.5 -61.5t50.5 -41.5t65.5 -15q27 0 56 8.5 t54.5 22.5t45.5 32.5t30 39.5l32 -10q-15 -27 -39 -50t-53.5 -39.5t-63 -26t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M216 -10q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102t93.5 71.5t110 27q33 0 60 -10t48.5 -27.5t37 -40.5t24.5 -48l69 328h35l-144 -674q-1 -3 -1 -5.5v-4.5q0 -14 14 -14l-7 -32q-12 0 -16 1q-13 2 -19 11t-6 20q0 2 0.5 5t2 10.5t4 21.5 t7.5 37q-42 -52 -100 -84t-114 -32zM227 22q27 0 61 12t65 32.5t55.5 48t33.5 57.5l38 179q-4 30 -19 56.5t-37 46t-49 31t-56 11.5q-52 0 -98.5 -25t-81 -65.5t-55 -90.5t-20.5 -100q0 -39 11.5 -74.5t33 -61.5t51.5 -41.5t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 301,
    d: "M136 490h-70l6 30h71l4 19q19 95 67 148t111 53q28 0 51.5 -9.5t35.5 -24.5l-21 -22q-10 11 -28.5 18t-39.5 7q-51 0 -88 -43.5t-54 -126.5l-4 -19h143l-6 -30h-144l-149 -703h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 581,
    d: "M166 -223q-44 0 -76 9t-54.5 25t-37 38.5t-23.5 49.5l28 14q18 -56 63.5 -81t105.5 -25q39 0 76 11t67.5 33.5t53 55.5t31.5 77l27 122q-42 -51 -100 -83t-114 -32q-44 0 -78 18t-58 48.5t-36.5 70t-12.5 82.5q0 59 24 116t64 102t93 72.5t112 27.5q33 0 59.5 -10t47 -27 t36.5 -40t28 -49l25 118h31l-114 -536q-11 -53 -38 -92t-63 -64.5t-79.5 -38t-87.5 -12.5zM226 22q33 0 67.5 13.5t64.5 35t52 48t31 53.5l38 179q-5 31 -19 58t-36 46t-49 30t-57 11q-54 0 -100.5 -26t-81 -67t-54 -91t-19.5 -97q0 -39 11.5 -74t33 -61.5t51.5 -42 t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 546,
    d: "M170 730h34l-72 -340q22 31 49 56.5t57 43.5t62 28t64 10q60 0 89 -35t29 -102q0 -21 -2.5 -45.5t-8.5 -51.5l-62 -294h-34l61 290q11 53 11 89q0 117 -97 117q-32 0 -66 -13t-65.5 -36t-57.5 -54.5t-43 -67.5l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34zM170 730h34l-18 -84h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 199,
    d: "M-114 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l117 553h34l-117 -552q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5zM177 730h34l-18 -84h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 525,
    d: "M170 730h34l-81 -381q61 88 129 135t138 47q58 0 89.5 -28t31.5 -77q0 -66 -57 -116t-157 -73l119 -237h-38l-124 255q109 22 166 65.5t57 100.5q0 39 -24.5 59.5t-69.5 20.5q-131 0 -271 -202l-63 -299h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 236,
    d: "M99 -5q-30 0 -47.5 17.5t-17.5 46.5v11t2 12l138 648h34l-137 -641q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -22 13.5 -34t37.5 -12q11 0 26 2.5t28 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 869,
    d: "M125 520h32l-27 -130q45 66 102.5 102t116.5 36q56 0 87 -34.5t31 -97.5q0 -5 -0.5 -9.5t-0.5 -9.5q20 37 46 65t56 47t62 29t64 10q59 0 86.5 -33t27.5 -97q0 -22 -3.5 -48t-9.5 -56l-62 -294h-34l61 290q5 27 8 51t3 44q0 111 -92 111q-32 0 -64 -12.5t-60.5 -35 t-53 -54.5t-42.5 -70l-68 -324h-34l61 290q12 57 12 97q0 109 -92 109q-32 0 -63.5 -12.5t-60 -35t-53.5 -54t-43 -69.5l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 546,
    d: "M125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 564,
    d: "M216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41 t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 582,
    d: "M126 520h31l-23 -108q42 51 100 83.5t115 32.5q44 0 78.5 -18.5t58.5 -49.5t36.5 -70.5t12.5 -82.5q0 -59 -23.5 -116t-63 -101.5t-92.5 -72t-112 -27.5q-32 0 -59 10t-48.5 27t-37 40t-25.5 49l-70 -329h-34zM245 22q52 0 98.5 25t81 65.5t55 90.5t20.5 100 q0 39 -11.5 74t-33 61.5t-51.5 42t-67 15.5q-27 0 -61 -12.5t-65 -33t-55.5 -47.5t-33.5 -57l-38 -179q6 -30 20.5 -56.5t35.5 -46t47.5 -31t57.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 581,
    d: "M205 -10q-43 0 -76 17.5t-55.5 47.5t-34 69t-11.5 81q0 63 26 121t68 103t96 72t111 27q58 0 102 -33.5t63 -82.5l22 108h32l-144 -678q-1 -4 -1 -8q0 -13 14 -15l-6 -31q-17 0 -30.5 7.5t-13.5 27.5q0 4 2 10l60 283q-54 -62 -110 -94t-114 -32zM218 22q33 0 64.5 11.5 t60 31t52.5 45.5t44 54l41 188q-4 29 -16.5 55.5t-32 46t-46 31t-58.5 11.5q-52 0 -100 -25t-84.5 -65.5t-58.5 -92t-22 -103.5q0 -38 10.5 -72.5t30.5 -60t49 -40.5t66 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 325,
    d: "M125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 455,
    d: "M163 -10q-57 0 -102.5 20t-74.5 62l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5q0 43 18 76t47.5 54.5t68 32.5t79.5 11q59 0 97.5 -21t52.5 -53l-25 -17 q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16.5 -70t-46 -55t-70 -36t-88.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 293,
    d: "M124 -5q-33 0 -54.5 17.5t-21.5 48.5q0 5 0.5 10t1.5 10l87 409h-70l6 30h71l38 179h34l-38 -179h117l-7 -30h-117l-78 -363q-5 -23 -7 -34t-2 -17q0 -24 15.5 -36.5t37.5 -12.5q15 0 29.5 3.5t26 8t19 8.5t9.5 5l6 -28q-2 -2 -11 -6.5t-23 -9.5t-32 -9t-37 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 463,
    d: "M62 520h36l74 -482q48 55 88 116.5t72.5 124.5t57 124t41.5 117h34q-40 -131 -109 -263t-177 -257h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 732,
    d: "M59 520h35l87 -482q53 58 96 123.5t78 131.5l-45 227h35l34 -180q23 48 40.5 93t31.5 87h33q-35 -114 -95 -229l48 -253q49 55 90.5 116.5t75 124.5t59 124t43.5 117h33q-41 -131 -111.5 -263t-181.5 -257h-34l-47 247q-35 -63 -78.5 -125t-97.5 -122h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 463,
    d: "M203 258l-140 262h40l120 -226l4 -13l227 239h39l-250 -262l139 -258h-40l-119 224l-5 12l-224 -236h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 468,
    d: "M-37 -196q31 6 52.5 15t39.5 24.5t35 39t39 56.5l38 59l-115 522h36l104 -484l53 85q46 73 78 128t54 100t37 85.5t28 85.5h34q-14 -48 -29 -89.5t-38 -88t-56.5 -103.5t-83.5 -136l-81 -129q-35 -56 -62 -92.5t-51.5 -58.5t-49.5 -32.5t-58 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 460,
    d: "M-30 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 227,
    d: "M212 709l-62 -291q-2 -8 -9 -26t-25 -32q7 -8 9 -17.5t2 -19.5q0 -13 -2 -21l-64 -302h53l-7 -31h-63q-6 0 -11 4t-5 15q0 7 1 11l64 298q2 10 2 17q0 12 -5.5 21t-17.5 11l6 30q10 0 17.5 6t12.5 13.5t7.5 15.5t3.5 12l61 287q4 20 13.5 25t14.5 5h63l-7 -31h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 264,
    d: "M121 -130v905h32v-905h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 227,
    d: "M137 709l6 31h62q4 0 10.5 -3.5t6.5 -17.5q0 -6 -1 -9l-61 -287q-2 -6 -2 -16q0 -11 4.5 -21t18.5 -10l-6 -30q-18 -2 -28 -17t-14 -32l-63 -298q-4 -17 -12.5 -23.5t-16.5 -6.5h-62l6 31h52l65 302q1 7 9 25.5t25 32.5q-7 8 -9.5 18t-2.5 19q0 13 2 21l63 291h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 457,
    d: "M55 248q0 3 5.5 16.5t17.5 29.5t29.5 28.5t41.5 12.5q21 0 39.5 -9.5t36 -20.5t35.5 -20.5t38 -9.5q18 0 31.5 7.5t22 17.5t13 18.5t4.5 10.5l27 -1q0 -1 -6 -13.5t-18 -27.5t-31 -27t-46 -12q-24 0 -44 9.5t-37.5 20.5t-34 20.5t-32.5 9.5t-28 -9t-20.5 -20t-13 -20.5 t-4.5 -10.5h-26v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 253
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 231,
    d: "M176 508l-108 -509h-34l108 509h34zM220 716l-19 -92h-38l23 92h34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 527,
    d: "M175 -120l24 111q-40 3 -71.5 23t-53 50t-33 68t-11.5 78q0 57 22.5 112t61 99.5t90 73.5t109.5 33l25 117h24l-25 -117q73 -2 111 -34.5t52 -83.5l-36 -12q-15 49 -50 72.5t-83 25.5l-101 -474q21 0 48.5 7.5t53.5 21t47.5 32.5t32.5 42l32 -10q-17 -31 -43.5 -54.5 t-57 -39t-62 -23.5t-58.5 -8l-24 -110h-24zM65 214q0 -36 10 -69t28 -58.5t44 -42.5t59 -20l100 471q-52 -3 -96 -30.5t-76.5 -68t-50.5 -88.5t-18 -94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 455,
    d: "M65 368h99q-11 39 -23.5 75t-12.5 75q0 40 17 75.5t45.5 62.5t64 43t73.5 16q48 0 84.5 -28.5t52.5 -76.5l-27 -21q-14 45 -45.5 70t-73.5 25q-29 0 -57.5 -13t-50.5 -35t-35.5 -51.5t-13.5 -62.5q0 -38 12.5 -75t23.5 -79h168l-7 -30h-155q2 -12 3.5 -23.5t1.5 -24.5 q0 -30 -5 -56.5t-22 -56t-48.5 -65t-84.5 -84.5q35 8 70 8q21 0 38 -3t32.5 -6.5t31 -6.5t33.5 -3q36 0 95 20l3 -29q-58 -23 -107 -23q-21 0 -38.5 3.5t-34 7t-34 7t-38.5 3.5t-47.5 -3.5t-49.5 -9.5l-6 26q60 53 95 89.5t54 65.5t24.5 54.5t5.5 57.5q0 14 -1.5 26.5 t-3.5 25.5h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 554,
    d: "M164 471q23 21 53 33t64 12q35 0 66 -12.5t54 -34.5l70 70l20 -20l-71 -70q18 -24 28.5 -53t10.5 -61q0 -64 -41 -114l73 -71l-19 -19l-73 71q-23 -21 -53 -33.5t-65 -12.5q-34 0 -63.5 12t-52.5 32l-70 -69l-19 19l71 69q-42 50 -42 116q0 33 10.5 62.5t29.5 53.5 l-69 68l20 20zM136 334q0 -31 11.5 -58.5t31.5 -48t46 -32.5t56 -12t56.5 12t47 33t32 49t11.5 59q0 32 -11.5 59.5t-32 48t-47 32.5t-56.5 12q-29 0 -55.5 -12t-46.5 -33t-31.5 -49t-11.5 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 634,
    d: "M385 348h86l-6 -28h-103l-40 -48l-5 -25h132l-6 -28h-132l-47 -219h-35l47 219h-132l6 28h132l6 27l-19 46h-103l6 28h87l-147 362h39l161 -403l334 403h39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 258,
    d: "M150 283v-413h-32v413h32zM150 775v-413h-32v413h32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 474,
    d: "M355 185q16 -11 23.5 -30t7.5 -44q0 -49 -22 -86.5t-55 -62.5t-72 -37.5t-73 -12.5q-62 0 -100.5 25.5t-62.5 59.5l28 21q29 -37 63 -55t79 -18q30 0 61.5 10.5t57.5 31t43 49.5t17 65q0 27 -11 43.5t-28 25.5t-39 12.5t-44 4.5q-32 1 -59.5 9t-48 23t-32 38t-11.5 55 q0 36 16.5 69t36.5 52q-16 11 -24.5 35.5t-8.5 52.5q0 46 21 82t53 61t70 38t73 13q66 0 98 -22.5t48 -58.5l-31 -13q-5 19 -17.5 31t-29.5 19t-36.5 9.5t-37.5 2.5q-29 0 -60.5 -11t-57 -31t-42 -49t-16.5 -66q0 -52 34.5 -73.5t90.5 -21.5q30 0 57.5 -6.5t49.5 -21.5 t35 -38t13 -56q0 -36 -17 -70t-40 -54zM110 312q0 -30 11.5 -48t30 -28.5t42 -15t47.5 -7.5t46 -6t38 -10q23 17 38.5 46.5t15.5 59.5q0 27 -11.5 46t-30 30t-41.5 16t-45 5q-26 0 -50 4.5t-42 13.5q-20 -17 -34.5 -45t-14.5 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 254,
    d: "M47 647l17 82h31l-17 -82h-31zM167 647l17 82h31l-17 -82h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 839,
    d: "M430 -7q-78 0 -144.5 27.5t-115 76t-76 114.5t-27.5 144q0 77 27.5 143t76 114t115 75.5t144.5 27.5t144.5 -27.5t115 -75.5t76 -114t27.5 -143q0 -78 -27.5 -144t-76 -114.5t-115 -76t-144.5 -27.5zM431 17q71 0 132.5 24.5t107 68.5t71.5 105.5t26 136.5 q0 73 -25.5 135.5t-70.5 107.5t-106.5 70.5t-134.5 25.5t-135 -25.5t-107.5 -70.5t-71 -106.5t-25.5 -134.5q0 -72 25.5 -134t70.5 -107t107 -70.5t136 -25.5zM437 126q-40 0 -80 15.5t-71.5 45t-51.5 72t-20 96.5q0 40 13 81.5t39.5 75t67 54.5t96.5 21q29 0 56.5 -6.5 t50.5 -19t41 -32t28 -45.5l-32 -11q-11 26 -29 42t-38.5 25t-40.5 12t-36 3q-47 0 -81 -18t-56.5 -47t-33 -64.5t-10.5 -70.5q0 -47 17.5 -84t44.5 -62.5t59.5 -38.5t62.5 -13q21 0 43.5 6t43.5 17t37.5 27.5t25.5 36.5l32 -9q-5 -15 -19.5 -33.5t-38 -35.5t-54 -28.5 t-66.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 407,
    d: "M170 350q-42 0 -67 25.5t-25 63.5q0 27 13 49.5t35.5 38.5t52.5 25t65 9q28 0 54.5 -4.5t46.5 -13.5l7 33q3 15 3 27q0 35 -21 55.5t-60 20.5q-51 0 -119 -41l-9 25q76 46 136 46q54 0 82.5 -25.5t28.5 -73.5q0 -9 -1 -18.5t-3 -19.5l-34 -163q-1 -2 -1 -7q0 -10 12 -11 l-8 -35q-23 0 -31 9t-8 23q0 12 3 27q-30 -32 -70 -48.5t-82 -16.5zM185 381q22 0 45.5 6t44 16.5t35 24.5t17.5 30l12 58q-20 11 -44.5 14.5t-50.5 3.5q-55 0 -91.5 -23.5t-36.5 -64.5q0 -27 18.5 -46t50.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 513,
    d: "M36 270l265 172l-7 -33l-231 -150l167 -150l-7 -33l-192 171zM213 270l266 172l-8 -33l-231 -150l167 -150l-6 -33l-192 171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 546,
    d: "M486 346l-45 -210h-31l38 177h-363l7 33h394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 527,
    d: "M57 255l6 33h395l-7 -33h-394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 839,
    d: "M430 -7q-78 0 -144.5 27.5t-115 76t-76 114.5t-27.5 144q0 77 27.5 143t76 114t115 75.5t144.5 27.5t144.5 -27.5t115 -75.5t76 -114t27.5 -143q0 -78 -27.5 -144t-76 -114.5t-115 -76t-144.5 -27.5zM430 16q72 0 133.5 24.5t107 69t71.5 107t26 138.5q0 72 -25.5 133.5 t-70.5 106.5t-107 70.5t-135 25.5t-134.5 -25.5t-106.5 -70.5t-70.5 -106.5t-25.5 -133.5q0 -73 25 -135t70 -107.5t107 -71t135 -25.5zM283 582h189q29 0 53 -12t41.5 -32t27 -45.5t9.5 -51.5t-8 -50t-23 -42.5t-36 -30.5t-46 -15l115 -180h-34l-113 178h-145v-178h-30v459 zM475 328q49 0 74 33.5t25 79.5q0 23 -7.5 43.5t-21.5 35.5t-33 24t-41 9h-158v-225h162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 366,
    d: "M54 679l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 249,
    d: "M180 578q-25 0 -40.5 16t-15.5 41q0 16 7 32t19 29t28 20.5t34 7.5q25 0 40.5 -17t15.5 -43q0 -17 -7.5 -32.5t-19.5 -27.5t-28 -19t-33 -7zM186 603q9 0 19.5 4.5t18.5 12.5t13.5 18t5.5 22q0 18 -10 27t-27 9q-21 0 -37.5 -15.5t-16.5 -38.5q0 -17 8.5 -28t25.5 -11z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 483,
    d: "M74 78v31h307v-31h-307zM381 373v-31h-137v-147h-33v147h-137v31h137v147h33v-147h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 360,
    d: "M65 418q16 76 55 115t100 61q26 9 53.5 18t50.5 22t37.5 32t14.5 49q0 28 -21 49t-66 21q-26 0 -47 -6t-38 -15t-29.5 -19.5t-20.5 -18.5l-15 18q2 3 14 13.5t32.5 22.5t48.5 21.5t63 9.5q57 0 83 -26.5t26 -64.5q0 -35 -15.5 -58.5t-40 -39.5t-53.5 -26t-56 -19 q-38 -12 -62.5 -29t-39 -35t-21.5 -36t-10 -33h240l-5 -26h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 366,
    d: "M205 413q-60 0 -91 26t-33 68l22 13q0 -36 27.5 -58t79.5 -22q27 0 51.5 7t43.5 19t30 29t11 37q0 33 -33 52.5t-92 19.5h-21l5 24h21q69 0 107.5 22t38.5 64q0 32 -26.5 52t-68.5 20q-39 0 -72.5 -16.5t-51.5 -42.5l-15 19q21 30 60.5 47.5t83.5 17.5q54 0 86.5 -26 t32.5 -66q0 -38 -26.5 -64.5t-79.5 -37.5q37 -7 57.5 -29.5t20.5 -53.5q0 -27 -14 -49.5t-37.5 -38t-54 -24.5t-62.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 195,
    d: "M59 638l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    d: "M134 520h34l-62 -292q-11 -50 -11 -84q0 -63 22.5 -92.5t76.5 -29.5q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h35l-99 -466q-1 -3 -1 -8q0 -14 14 -14l-8 -32q-17 0 -28 8.5t-11 31.5q0 2 2.5 14.5l5.5 27.5t6 28.5t4 17.5q-22 -31 -49.5 -56.5t-58.5 -43.5 t-63.5 -28t-64.5 -10q-50 0 -77.5 25t-33.5 73l-63 -300h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 552,
    d: "M64 429q0 63 23 115t65 88.5t102 57t134 20.5h203l-7 -30h-66l-162 -760h-31l69 323h-81l-69 -323h-32l69 323q-104 2 -160.5 51t-56.5 135zM96 436q0 -41 15 -71t41 -50t60.5 -30t74.5 -12l87 407q-66 0 -118 -18t-87.5 -50t-54 -77t-18.5 -99zM487 680h-81l-87 -407h81 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 164,
    d: "M55 249l19 91h31l-19 -91h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 248,
    d: "M6 -125q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l73 97l19 -12l-44 -56q10 4 21 5t19 1q56 0 56 -44q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 246,
    d: "M257 444l-6 -27h-178l6 27h78l71 334q-6 -6 -18.5 -14.5t-27 -16t-29.5 -12.5t-27 -5l6 27q15 0 32.5 8t33 18t26 18.5t10.5 9.5h28l-79 -367h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 431,
    d: "M223 350q-31 0 -55.5 11.5t-42 31.5t-26.5 46.5t-9 56.5q0 42 17.5 80.5t46.5 68t66.5 47t78.5 17.5q31 0 56 -11.5t43 -31.5t27.5 -47t9.5 -57q0 -41 -17.5 -79.5t-47 -68t-67.5 -47t-80 -17.5zM229 377q33 0 64 15t55.5 39.5t39.5 57.5t15 69q0 26 -8 48.5t-22.5 39 t-34.5 26t-44 9.5q-32 0 -63 -14.5t-55.5 -39.5t-39.5 -58t-15 -70q0 -26 8 -48t22 -38.5t34 -26t44 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 513,
    d: "M459 247l-264 -171l6 33l231 150l-167 150l7 33l192 -172zM282 247l-265 -171l7 33l231 150l-167 150l7 33l191 -172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 732,
    d: "M575 108h-220l5 24l282 256h19l-54 -254h53l-5 -26h-53l-24 -108h-26zM581 134l45 211l-232 -211h187zM40 16l676 696l18 -17l-676 -697zM247 364l-6 -27h-178l6 27h78l71 334q-6 -6 -18.5 -14.5t-27 -16t-29.5 -12.5t-27 -5l6 27q15 0 32.5 8t33 18t26 18.5t10.5 9.5h28 l-79 -367h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 773,
    d: "M393 0q16 75 55 114.5t99 61.5q26 9 53.5 18t50 21.5t37 31.5t14.5 49q0 29 -20.5 50t-65.5 21q-26 0 -47 -6t-38 -15t-29.5 -19.5t-19.5 -18.5l-15 18q2 3 14 13.5t32 22.5t48 21.5t62 9.5q57 0 83 -26.5t26 -64.5q0 -35 -15.5 -58.5t-39.5 -39.5t-53 -26.5t-56 -19.5 q-38 -13 -62 -29.5t-38.5 -34.5t-21.5 -35.5t-10 -32.5h240l-6 -26h-277zM15 16l676 696l18 -17l-676 -697zM252 364l-6 -27h-178l6 27h78l71 334q-6 -6 -18.5 -14.5t-27 -16t-29.5 -12.5t-27 -5l6 27q15 0 32.5 8t33 18t26 18.5t10.5 9.5h28l-79 -367h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 749,
    d: "M189 333q-21 0 -43 5.5t-40 17t-29 29.5t-11 42l22 13q0 -32 27.5 -56t79.5 -24q27 0 51.5 7t43.5 19t30 29t11 37q0 33 -33.5 52.5t-91.5 19.5h-21l5 24h21q69 0 107.5 22.5t38.5 64.5q0 32 -26.5 51.5t-68.5 19.5q-40 0 -73 -16.5t-51 -42.5l-15 19q21 30 60.5 47.5 t83.5 17.5q54 0 86.5 -26t32.5 -66q0 -39 -26.5 -65t-79.5 -37q37 -7 57.5 -30t20.5 -53q0 -27 -14 -49.5t-37.5 -38t-54 -24.5t-63.5 -9zM585 108h-220l5 24l282 256h19l-54 -254h53l-5 -26h-53l-24 -108h-26zM591 134l45 211l-232 -211h187zM75 16l676 696l18 -17 l-676 -697z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 447,
    d: "M292 320q-9 -44 -21 -73.5t-27 -50.5t-32.5 -34.5t-38.5 -23.5q-28 -14 -59 -28t-57.5 -35t-43.5 -53t-17 -84q0 -31 9.5 -53.5t26 -37.5t38.5 -22t46 -7q55 0 108 30.5t88 81.5l23 -14q-20 -31 -46.5 -55t-56 -40.5t-61 -25t-61.5 -8.5t-56.5 9.5t-47 28t-32 46.5 t-11.5 64q0 55 17 90.5t44 59t60.5 40t66.5 33.5q18 9 34 20t30 28.5t25.5 44.5t20.5 69h31zM331 506l-19 -91h-31l19 91h31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM376 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM429 826l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM339 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM496 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6 q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM361 835l17 82h31l-17 -82h-31zM481 835l17 82h31l-17 -82h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM384 847q0 30 22.5 50.5t51.5 20.5q22 0 34.5 -13.5t12.5 -34.5q0 -29 -22 -50t-51 -21q-22 0 -35 13.5t-13 34.5zM453 899q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5 q17 0 33 14t16 34q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 922,
    d: "M509 710h445l-7 -32h-402l-63 -299h350l-7 -32h-350l-67 -315h410l-7 -32h-444l52 245h-260l-202 -245h-40zM425 277l81 386l-322 -386h241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 658,
    d: "M194 -125q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l59 79q-55 3 -97.5 29t-72 67.5t-44.5 93.5t-15 108q0 73 30 147.5t84 135.5t127.5 99.5t160.5 38.5q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42 t-55.5 23t-61 7q-78 0 -143.5 -35.5t-113 -91.5t-74.5 -124.5t-27 -135.5q0 -54 15.5 -102.5t44.5 -85t69.5 -58t91.5 -21.5q32 0 67 8.5t70 26t67.5 44.5t59.5 65l28 -12q-25 -39 -59 -68.5t-73 -50.5t-80 -32.5t-79 -12.5l-38 -50q10 4 21 5t19 1q56 0 56 -44 q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447zM364 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 586,
    d: "M405 826l-21 13l76 79h44zM181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 586,
    d: "M331 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 586,
    d: "M349 835l17 82h31l-17 -82h-31zM469 835l17 82h31l-17 -82h-31zM181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM160 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM213 826l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM123 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM147 835l17 82h31l-17 -82h-31zM267 835l17 82h31l-17 -82h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 693,
    d: "M52 372h64l72 338h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221l72 342h-63zM265 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186l-66 -306h176l-6 -30h-176 l-66 -310h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 742,
    d: "M181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35zM550 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5 t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 725,
    d: "M297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5 t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5zM424 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 725,
    d: "M467 826l-21 13l76 79h44zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139 q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 725,
    d: "M379 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5 t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 725,
    d: "M297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5 t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5zM534 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5 t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 725,
    d: "M401 835l17 82h31l-17 -82h-31zM521 835l17 82h31l-17 -82h-31zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28 q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 462,
    d: "M378 140l-24 -23l-131 131l-131 -131l-22 24l130 130l-131 131l24 23l130 -131l132 132l22 -24l-131 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 725,
    d: "M690 710l-64 -77q35 -42 53 -97t18 -115q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36q-47 0 -85.5 15t-67.5 42l-43 -52h-40l61 74q-35 42 -53.5 97t-18.5 116q0 82 34 159t90 137t128 96t149 36q47 0 85.5 -16t68.5 -44l45 55h40zM85 291q0 -55 15.5 -103.5 t45.5 -85.5l436 526q-27 25 -61.5 39.5t-76.5 14.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 54 -15.5 102t-44.5 85l-436 -525q27 -25 61.5 -38.5t76.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5zM421 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 724,
    d: "M449 826l-21 13l76 79h44zM298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356 q-15 -71 -43 -136t-71.5 -114.5t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 724,
    d: "M374 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5 l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 724,
    d: "M397 835l17 82h31l-17 -82h-31zM517 835l17 82h31l-17 -82h-31zM298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5 t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 598,
    d: "M271 274l-176 436h39l162 -403l334 403h38l-363 -438l-58 -272h-34zM380 826l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 575,
    d: "M181 710h35l-32 -147h224q36 0 64 -15t47.5 -40.5t29.5 -58t10 -66.5q0 -47 -19 -92.5t-51.5 -82t-76 -59t-91.5 -22.5h-230l-26 -127h-35zM327 159q42 0 78 20t62.5 51.5t42 71t15.5 77.5q0 30 -9 57.5t-25.5 48.5t-40 33t-51.5 12h-221l-79 -371h228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 525,
    d: "M164 26q124 2 195.5 58.5t71.5 156.5q0 66 -40 105.5t-110 39.5h-17l7 32h16q33 0 63.5 12t53.5 33t36.5 49.5t13.5 60.5q0 49 -32 79t-84 30q-68 0 -117 -48t-66 -126l-107 -508h-33l108 511q10 45 31 82.5t50.5 64.5t65.5 41.5t76 14.5q32 0 58.5 -10t45 -27t29 -41.5 t10.5 -52.5q0 -31 -12.5 -61t-33 -54t-46.5 -41t-54 -23q61 -14 92 -56t31 -102q0 -57 -21.5 -103t-61 -78t-97 -50t-129.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM314 730h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM344 638l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM260 653l106 77h26l74 -77l-25 -15 l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM414 656q-21 0 -35.5 6t-26.5 13t-23 13 t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM282 647l17 82h31l-17 -82h-31zM402 647 l17 82h31l-17 -82h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM301 659q0 30 22.5 50.5t51.5 20.5 q22 0 34.5 -13.5t12.5 -34.5q0 -29 -22 -50t-51 -21q-22 0 -35 13.5t-13 34.5zM370 711q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5q17 0 33 14t16 34q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 884,
    d: "M136 -10q-34 0 -59.5 10.5t-42.5 28.5t-25.5 41.5t-8.5 50.5q0 40 18.5 73t51 56.5t76.5 36.5t95 13q33 0 66.5 -5.5t62.5 -14.5q7 26 18 50t22 47q0 55 -32 88.5t-89 33.5q-39 0 -83 -16.5t-92 -47.5l-10 25q56 35 102.5 51.5t90.5 16.5q58 0 96 -30.5t46 -87.5 q42 53 99.5 85.5t120.5 32.5q42 0 77.5 -15.5t61 -43t40 -64.5t14.5 -80q0 -21 -3.5 -43.5t-9.5 -36.5h-443q-3 -21 -3 -40q0 -40 11.5 -74t33 -59t52 -39t67.5 -14q27 0 55 7.5t53 21.5t46 33.5t36 42.5l29 -8q-16 -27 -41 -50.5t-55 -40t-64 -26t-67 -9.5q-63 0 -108 32.5 t-66 86.5q-22 -32 -53 -55t-64 -37t-65 -20.5t-57 -6.5zM148 19q30 0 64.5 9t65 25.5t54.5 39t33 48.5q-7 24 -7 56q0 27 6 56q-29 11 -61 16t-63 5q-45 0 -83 -10.5t-65.5 -29.5t-43 -46.5t-15.5 -60.5q0 -21 6.5 -40.5t21 -34.5t36 -24t51.5 -9zM812 272q6 25 6 52 q0 35 -10.5 66.5t-31 55.5t-51.5 38t-71 14q-42 0 -82 -17t-74 -47t-59 -71.5t-38 -90.5h411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 517,
    d: "M122 -125q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l56 75q-39 3 -71 21.5t-54.5 48t-35 67.5t-12.5 82q0 64 25 122t67 101.5t97 69t115 25.5q66 0 109 -31.5t57 -86.5l-36 -12q-14 46 -51 72t-88 26q-50 0 -96.5 -22.5t-83 -61 t-58.5 -89.5t-22 -108q0 -40 11.5 -75t32.5 -61.5t50.5 -41.5t65.5 -15q27 0 56 8.5t54.5 22.5t45.5 32.5t30 39.5l32 -10q-14 -26 -37 -48.5t-51.5 -39t-60.5 -26.5t-64 -11l-35 -45q10 4 21 5t19 1q56 0 56 -44q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6zM320 730h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 525,
    d: "M333 638l-21 13l76 79h44zM222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8 t53 22.5t47.5 35t36 46.5l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 525,
    d: "M266 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61 t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5 t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 525,
    d: "M283 647l17 82h31l-17 -82h-31zM403 647l17 82h31l-17 -82h-31zM222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74 t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5 t-30.5 33.5t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34zM93 730h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 191,
    d: "M165 638l-21 13l76 79h44zM125 520h34l-110 -520h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 191,
    d: "M66 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM125 520h34l-110 -520h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 191,
    d: "M92 647l17 82h31l-17 -82h-31zM212 647l17 82h31l-17 -82h-31zM125 520h34l-110 -520h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 571,
    d: "M540 694l-100 -59q51 -64 70 -132.5t19 -132.5q0 -88 -28 -158.5t-72.5 -119.5t-100.5 -75.5t-112 -26.5q-43 0 -78 16t-60 43t-39 63.5t-14 77.5q0 57 25 108.5t66.5 90.5t93.5 62.5t106 23.5q35 0 65 -10t53.5 -28.5t39 -43.5t21.5 -55q2 15 2 30v31q-2 54 -19 109.5 t-64 112.5l-130 -77l-9 19l125 73q-21 23 -47.5 47t-60.5 47h48q26 -19 47.5 -39t39.5 -40l103 62zM60 194q0 -36 12 -67.5t33.5 -54.5t51.5 -36.5t66 -13.5q48 0 94 21.5t82 57.5t58.5 82t22.5 95q0 34 -12.5 64.5t-34.5 53t-52.5 35.5t-66.5 13q-47 0 -92.5 -20.5 t-81.5 -55t-58 -80t-22 -94.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 546,
    d: "M125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34zM408 656q-21 0 -35.5 6t-26.5 13t-23 13 t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 564,
    d: "M216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41 t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15zM314 730h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 564,
    d: "M350 638l-21 13l76 79h44zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107 q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 564,
    d: "M257 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23 t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 564,
    d: "M216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41 t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15zM411 656q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5 t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 564,
    d: "M278 647l17 82h31l-17 -82h-31zM398 647l17 82h31l-17 -82h-31zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22 q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 545,
    d: "M250 389v72h32v-72h-32zM250 87v71h32v-71h-32zM65 259v31h403v-31h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 564,
    d: "M86 46q-28 30 -43 71.5t-15 89.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q33 0 61.5 -10.5t51.5 -30.5l28 33h31l-42 -50q27 -30 42 -71.5t15 -89.5q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-111.5 -26.5q-34 0 -62.5 10.5t-51.5 29.5l-26 -30h-31zM63 211 q0 -42 12 -77t35 -61l311 386q-20 17 -44.5 27t-52.5 10q-48 0 -94.5 -23.5t-83.5 -63t-60 -91t-23 -107.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 41 -12 77t-35 62l-312 -385q41 -36 97 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5zM273 730h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 556,
    d: "M318 638l-21 13l76 79h44zM165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5 t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 556,
    d: "M242 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1 q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 556,
    d: "M265 647l17 82h31l-17 -82h-31zM385 647l17 82h31l-17 -82h-31zM165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32 q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 468,
    d: "M-37 -196q31 6 52.5 15t39.5 24.5t35 39t39 56.5l38 59l-115 522h36l104 -484l53 85q46 73 78 128t54 100t37 85.5t28 85.5h34q-14 -48 -29 -89.5t-38 -88t-56.5 -103.5t-83.5 -136l-81 -129q-35 -56 -62 -92.5t-51.5 -58.5t-49.5 -32.5t-58 -14.5zM280 638l-21 13l76 79 h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 576,
    d: "M166 710h34l-64 -302q46 53 99.5 86.5t116.5 33.5q45 0 78.5 -17.5t56 -46.5t33.5 -66t11 -77q0 -57 -22 -116.5t-61 -107.5t-93 -78.5t-119 -30.5q-66 0 -106.5 31t-59.5 79l-66 -311h-34zM245 21q47 0 92 23.5t80.5 63.5t57 93t21.5 112q0 39 -10 72.5t-29.5 58 t-47.5 38.5t-65 14q-33 0 -63.5 -11t-58.5 -30.5t-53 -45.5t-45 -55l-39 -184q-2 -6 -2 -9.5v-5.5q0 -28 13.5 -52.5t36 -42.5t52 -28.5t60.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 468,
    d: "M-37 -196q31 6 52.5 15t39.5 24.5t35 39t39 56.5l38 59l-115 522h36l104 -484l53 85q46 73 78 128t54 100t37 85.5t28 85.5h34q-14 -48 -29 -89.5t-38 -88t-56.5 -103.5t-83.5 -136l-81 -129q-35 -56 -62 -92.5t-51.5 -58.5t-49.5 -32.5t-58 -14.5zM218 647l17 82h31 l-17 -82h-31zM338 647l17 82h31l-17 -82h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM311 867l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM234 679l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM438 856q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM357 668q20 0 39.5 18t27.5 44h24 q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 648,
    d: "M486 -164q-22 6 -33 20t-11 33q0 27 20 52.5t69 58.5l-47 245h-336l-151 -245h-38l441 710h30l138 -710q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37zM480 275l-74 391l-242 -391h316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    d: "M375 -164q-22 6 -33 20t-11 33q0 28 22 54t75 61q-12 9 -12 27q0 3 0.5 6.5t2 11t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118 h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5 t33 -60.5t50.5 -41.5t64.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 661,
    d: "M473 826l-21 13l76 79h44zM295 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 73 30 147.5t84 135.5t127.5 99.5t160.5 38.5q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42t-55.5 23t-61 7q-78 0 -143.5 -35.5t-113 -91.5t-74.5 -124.5 t-27 -135.5q0 -54 15.5 -102.5t44.5 -85t69.5 -58t91.5 -21.5q32 0 67 8.5t70 26t67.5 44.5t59.5 65l28 -12q-26 -40 -61.5 -71t-76.5 -52t-83.5 -31.5t-81.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 517,
    d: "M332 638l-21 13l76 79h44zM220 -10q-43 0 -78.5 17t-60.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101.5t97 69t115 25.5q66 0 109 -31.5t57 -86.5l-36 -12q-14 46 -51 72t-88 26q-50 0 -96.5 -22.5t-83 -61t-58.5 -89.5t-22 -108q0 -40 11.5 -75t32.5 -61.5t50.5 -41.5 t65.5 -15q27 0 56 8.5t54.5 22.5t45.5 32.5t30 39.5l32 -10q-15 -27 -39 -50t-53.5 -39.5t-63 -26t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 661,
    d: "M385 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM295 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 73 30 147.5t84 135.5t127.5 99.5t160.5 38.5q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42t-55.5 23t-61 7q-78 0 -143.5 -35.5 t-113 -91.5t-74.5 -124.5t-27 -135.5q0 -54 15.5 -102.5t44.5 -85t69.5 -58t91.5 -21.5q32 0 67 8.5t70 26t67.5 44.5t59.5 65l28 -12q-26 -40 -61.5 -71t-76.5 -52t-83.5 -31.5t-81.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 517,
    d: "M263 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM220 -10q-43 0 -78.5 17t-60.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101.5t97 69t115 25.5q66 0 109 -31.5t57 -86.5l-36 -12q-14 46 -51 72t-88 26q-50 0 -96.5 -22.5t-83 -61t-58.5 -89.5t-22 -108q0 -40 11.5 -75 t32.5 -61.5t50.5 -41.5t65.5 -15q27 0 56 8.5t54.5 22.5t45.5 32.5t30 39.5l32 -10q-15 -27 -39 -50t-53.5 -39.5t-63 -26t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 661,
    d: "M295 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 73 30 147.5t84 135.5t127.5 99.5t160.5 38.5q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42t-55.5 23t-61 7q-78 0 -143.5 -35.5t-113 -91.5t-74.5 -124.5t-27 -135.5q0 -54 15.5 -102.5 t44.5 -85t69.5 -58t91.5 -21.5q32 0 67 8.5t70 26t67.5 44.5t59.5 65l28 -12q-26 -40 -61.5 -71t-76.5 -52t-83.5 -31.5t-81.5 -10.5zM470 835l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 517,
    d: "M220 -10q-43 0 -78.5 17t-60.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101.5t97 69t115 25.5q66 0 109 -31.5t57 -86.5l-36 -12q-14 46 -51 72t-88 26q-50 0 -96.5 -22.5t-83 -61t-58.5 -89.5t-22 -108q0 -40 11.5 -75t32.5 -61.5t50.5 -41.5t65.5 -15q27 0 56 8.5 t54.5 22.5t45.5 32.5t30 39.5l32 -10q-15 -27 -39 -50t-53.5 -39.5t-63 -26t-66.5 -9.5zM344 647l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 661,
    d: "M391 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM295 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 73 30 147.5t84 135.5t127.5 99.5t160.5 38.5q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42t-55.5 23t-61 7q-78 0 -143.5 -35.5 t-113 -91.5t-74.5 -124.5t-27 -135.5q0 -54 15.5 -102.5t44.5 -85t69.5 -58t91.5 -21.5q32 0 67 8.5t70 26t67.5 44.5t59.5 65l28 -12q-26 -40 -61.5 -71t-76.5 -52t-83.5 -31.5t-81.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 517,
    d: "M269 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM220 -10q-43 0 -78.5 17t-60.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101.5t97 69t115 25.5q66 0 109 -31.5t57 -86.5l-36 -12q-14 46 -51 72t-88 26q-50 0 -96.5 -22.5t-83 -61t-58.5 -89.5t-22 -108q0 -40 11.5 -75 t32.5 -61.5t50.5 -41.5t65.5 -15q27 0 56 8.5t54.5 22.5t45.5 32.5t30 39.5l32 -10q-15 -27 -39 -50t-53.5 -39.5t-63 -26t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 686,
    d: "M353 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186 l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    d: "M621 651l76 79h44l-99 -92zM216 -10q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102t93.5 71.5t110 27q33 0 60 -10t48.5 -27.5t37 -40.5t24.5 -48l69 328h35l-144 -674q-1 -3 -1 -5.5v-4.5q0 -14 14 -14l-7 -32q-12 0 -16 1q-13 2 -19 11t-6 20 q0 2 0.5 5t2 10.5t4 21.5t7.5 37q-42 -52 -100 -84t-114 -32zM227 22q27 0 61 12t65 32.5t55.5 48t33.5 57.5l38 179q-4 30 -19 56.5t-37 46t-49 31t-56 11.5q-52 0 -98.5 -25t-81 -65.5t-55 -90.5t-20.5 -100q0 -39 11.5 -74.5t33 -61.5t51.5 -41.5t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 693,
    d: "M52 372h64l72 338h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221l72 342h-63zM265 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186l-66 -306h176l-6 -30h-176 l-66 -310h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M432 654h112l16 76h35l-16 -76h72l-5 -28h-73l-122 -570q-1 -3 -1 -5.5v-4.5q0 -14 14 -14l-7 -32q-12 0 -16 1q-13 2 -19 11t-6 20q0 2 0.5 5t2 10.5t4 21.5t7.5 37q-42 -52 -100 -84t-114 -32q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102 t93.5 71.5t110 27q33 0 60 -10t48.5 -27.5t37 -40.5t24.5 -48l47 224h-112zM227 22q27 0 61 12t65 32.5t55.5 48t33.5 57.5l38 179q-4 30 -19 56.5t-37 46t-49 31t-56 11.5q-52 0 -98.5 -25t-81 -65.5t-55 -90.5t-20.5 -100q0 -39 11.5 -74.5t33 -61.5t51.5 -41.5t67 -15.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447zM299 867l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6zM234 679l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447zM427 856q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6zM362 668q20 0 39.5 18t27.5 44h24 q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447zM413 835l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6zM345 647l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-198q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37l-19 -23q-22 6 -33 20t-11 33q0 27 20 52.5t71 58.5h-214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 525,
    d: "M164 -172q-22 6 -33 20t-11 33q0 27 20 52t68 58q-42 3 -75.5 21t-56.5 47.5t-35 68t-12 82.5q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5 q27 0 54.5 8t53 22.5t47.5 35t36 46.5l30 -9q-32 -55 -88 -90t-119 -41q-28 -17 -46.5 -30.5t-30 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5 q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 586,
    d: "M333 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 525,
    d: "M267 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61 t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5 t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 688,
    d: "M368 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM559 116q-125 -121 -259 -121q-60 0 -106 25t-78 66.5t-48.5 95t-16.5 110.5q0 78 32.5 154t87 135.5t125.5 96.5t148 37q51 0 89.5 -11.5t65.5 -32t44 -49t26 -62.5l-33 -15q-21 73 -72.5 105t-127.5 32 q-72 0 -136 -35t-112 -90.5t-75.5 -125t-27.5 -137.5q0 -54 16 -102.5t45 -84.5t70 -57.5t92 -21.5q64 0 127.5 31t132.5 98l33 154h-155l6 30h187l-73 -341h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 581,
    d: "M253 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM166 -223q-44 0 -76 9t-54.5 25t-37 38.5t-23.5 49.5l28 14q18 -56 63.5 -81t105.5 -25q39 0 76 11t67.5 33.5t53 55.5t31.5 77l27 122q-42 -51 -100 -83t-114 -32q-44 0 -78 18t-58 48.5t-36.5 70t-12.5 82.5 q0 59 24 116t64 102t93 72.5t112 27.5q33 0 59.5 -10t47 -27t36.5 -40t28 -49l25 118h31l-114 -536q-11 -53 -38 -92t-63 -64.5t-79.5 -38t-87.5 -12.5zM226 22q33 0 67.5 13.5t64.5 35t52 48t31 53.5l38 179q-5 31 -19 58t-36 46t-49 30t-57 11q-54 0 -100.5 -26t-81 -67 t-54 -91t-19.5 -97q0 -39 11.5 -74t33 -61.5t51.5 -42t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 688,
    d: "M559 116q-125 -121 -259 -121q-60 0 -106 25t-78 66.5t-48.5 95t-16.5 110.5q0 78 32.5 154t87 135.5t125.5 96.5t148 37q51 0 89.5 -11.5t65.5 -32t44 -49t26 -62.5l-33 -15q-21 73 -72.5 105t-127.5 32q-72 0 -136 -35t-112 -90.5t-75.5 -125t-27.5 -137.5 q0 -54 16 -102.5t45 -84.5t70 -57.5t92 -21.5q64 0 127.5 31t132.5 98l33 154h-155l6 30h187l-73 -341h-31zM469 856q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12 q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 581,
    d: "M166 -223q-44 0 -76 9t-54.5 25t-37 38.5t-23.5 49.5l28 14q18 -56 63.5 -81t105.5 -25q39 0 76 11t67.5 33.5t53 55.5t31.5 77l27 122q-42 -51 -100 -83t-114 -32q-44 0 -78 18t-58 48.5t-36.5 70t-12.5 82.5q0 59 24 116t64 102t93 72.5t112 27.5q33 0 59.5 -10t47 -27 t36.5 -40t28 -49l25 118h31l-114 -536q-11 -53 -38 -92t-63 -64.5t-79.5 -38t-87.5 -12.5zM226 22q33 0 67.5 13.5t64.5 35t52 48t31 53.5l38 179q-5 31 -19 58t-36 46t-49 30t-57 11q-54 0 -100.5 -26t-81 -67t-54 -91t-19.5 -97q0 -39 11.5 -74t33 -61.5t51.5 -42 t67 -15.5zM349 668q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 688,
    d: "M559 116q-125 -121 -259 -121q-60 0 -106 25t-78 66.5t-48.5 95t-16.5 110.5q0 78 32.5 154t87 135.5t125.5 96.5t148 37q51 0 89.5 -11.5t65.5 -32t44 -49t26 -62.5l-33 -15q-21 73 -72.5 105t-127.5 32q-72 0 -136 -35t-112 -90.5t-75.5 -125t-27.5 -137.5 q0 -54 16 -102.5t45 -84.5t70 -57.5t92 -21.5q64 0 127.5 31t132.5 98l33 154h-155l6 30h187l-73 -341h-31zM455 835l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 581,
    d: "M166 -223q-44 0 -76 9t-54.5 25t-37 38.5t-23.5 49.5l28 14q18 -56 63.5 -81t105.5 -25q39 0 76 11t67.5 33.5t53 55.5t31.5 77l27 122q-42 -51 -100 -83t-114 -32q-44 0 -78 18t-58 48.5t-36.5 70t-12.5 82.5q0 59 24 116t64 102t93 72.5t112 27.5q33 0 59.5 -10t47 -27 t36.5 -40t28 -49l25 118h31l-114 -536q-11 -53 -38 -92t-63 -64.5t-79.5 -38t-87.5 -12.5zM226 22q33 0 67.5 13.5t64.5 35t52 48t31 53.5l38 179q-5 31 -19 58t-36 46t-49 30t-57 11q-54 0 -100.5 -26t-81 -67t-54 -91t-19.5 -97q0 -39 11.5 -74t33 -61.5t51.5 -42 t67 -15.5zM333 647l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 688,
    d: "M238 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM559 116q-125 -121 -259 -121q-60 0 -106 25t-78 66.5t-48.5 95t-16.5 110.5q0 78 32.5 154t87 135.5t125.5 96.5t148 37q51 0 89.5 -11.5t65.5 -32t44 -49t26 -62.5l-33 -15q-21 73 -72.5 105t-127.5 32 q-72 0 -136 -35t-112 -90.5t-75.5 -125t-27.5 -137.5q0 -54 16 -102.5t45 -84.5t70 -57.5t92 -21.5q64 0 127.5 31t132.5 98l33 154h-155l6 30h187l-73 -341h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 581,
    d: "M386 733l-25 -62h12l-14 -64h-36l14 64l29 62h20zM166 -223q-44 0 -76 9t-54.5 25t-37 38.5t-23.5 49.5l28 14q18 -56 63.5 -81t105.5 -25q39 0 76 11t67.5 33.5t53 55.5t31.5 77l27 122q-42 -51 -100 -83t-114 -32q-44 0 -78 18t-58 48.5t-36.5 70t-12.5 82.5 q0 59 24 116t64 102t93 72.5t112 27.5q33 0 59.5 -10t47 -27t36.5 -40t28 -49l25 118h31l-114 -536q-11 -53 -38 -92t-63 -64.5t-79.5 -38t-87.5 -12.5zM226 22q33 0 67.5 13.5t64.5 35t52 48t31 53.5l38 179q-5 31 -19 58t-36 46t-49 30t-57 11q-54 0 -100.5 -26t-81 -67 t-54 -91t-19.5 -97q0 -39 11.5 -74t33 -61.5t51.5 -42t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 703,
    d: "M363 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM181 710h35l-71 -331h446l71 331h34l-151 -710h-34l74 347h-447l-73 -347h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 546,
    d: "M283 653l105 77h25l73 -77l-24 -15l-67 63l-93 -63zM170 730h34l-72 -340q22 31 49 56.5t57 43.5t62 28t64 10q60 0 89 -35t29 -102q0 -21 -2.5 -45.5t-8.5 -51.5l-62 -294h-34l61 290q11 53 11 89q0 117 -97 117q-32 0 -66 -13t-65.5 -36t-57.5 -54.5t-43 -67.5 l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 712,
    d: "M111 578h47l28 132h34l-28 -132h446l28 132h35l-28 -132h47l-6 -25h-47l-117 -553h-35l74 347h-446l-74 -347h-34l117 553h-47zM596 379l37 174h-447l-36 -174h446z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 546,
    d: "M84 654h70l16 76h34l-16 -76h114l-5 -28h-115l-50 -236q22 31 49 56.5t57 43.5t62 28t64 10q60 0 89 -35t29 -102q0 -21 -2.5 -45.5t-8.5 -51.5l-62 -294h-34l61 290q11 53 11 89q0 117 -97 117q-32 0 -66 -13t-65.5 -36t-57.5 -54.5t-43 -67.5l-69 -325h-34l133 626h-70 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM279 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25 t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34zM218 656q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25 t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM97 867l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34zM33 679l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM219 856q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34zM165 668q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 224,
    d: "M-16 -164q-22 6 -33 20t-11 33q0 27 20.5 52.5t70.5 58.5l151 709h35l-151 -709q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37l-19 -23v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 192,
    d: "M-32 -164q-22 6 -33 20t-11 33q0 28 20.5 53t71.5 59l110 519h34l-110 -520q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37zM171 730h34l-18 -84h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM207 835l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 684,
    d: "M181 709h35l-151 -709h-35zM327 -11q-85 0 -137 44l18 28q44 -39 125 -39q58 0 96.5 22t65.5 64t45 103t35 138l77 360h34l-77 -360q-17 -81 -37.5 -147.5t-52 -113.5t-77.5 -73t-115 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 390,
    d: "M125 520h34l-110 -520h-34zM170 730h34l-18 -84h-34zM77 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l117 553h34l-117 -552q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5zM368 730h34l-18 -84h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 461,
    d: "M367 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM104 -11q-85 0 -137 44l18 28q44 -39 125 -39q58 0 96.5 22t65.5 64t45 103t35 138l77 360h34l-77 -360q-17 -81 -37.5 -147.5t-52 -113.5t-77.5 -73t-115 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 191,
    d: "M-121 -173q-29 0 -53 7.5t-39 27.5l25 22q13 -15 32 -20t39 -5q18 0 38 8.5t37.5 23t30.5 34t18 42.5l118 553h34l-118 -552q-6 -31 -23.5 -57t-40 -44.5t-48.5 -29t-50 -10.5zM62 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 598,
    d: "M188 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM181 709h35l-95 -446l505 447h43l-350 -311l212 -399h-41l-199 378l-179 -158l-47 -220h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 525,
    d: "M138 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM170 730h34l-81 -381q61 88 129 135t138 47q58 0 89.5 -28t31.5 -77q0 -66 -57 -116t-157 -73l119 -237h-38l-124 255q109 22 166 65.5t57 100.5q0 39 -24.5 59.5t-69.5 20.5q-131 0 -271 -202l-63 -299h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 491,
    d: "M125 520h34l-66 -313l383 311h41l-254 -208l150 -310h-38l-141 288l-150 -121l-35 -167h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 553,
    d: "M219 826l-21 13l76 79h44zM181 710h35l-145 -678h413l-7 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 236,
    d: "M193 778l-21 13l76 79h44zM99 -5q-30 0 -47.5 17.5t-17.5 46.5v11t2 12l138 648h34l-137 -641q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -22 13.5 -34t37.5 -12q11 0 26 2.5t28 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 553,
    d: "M197 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM181 710h35l-145 -678h413l-7 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 236,
    d: "M38 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM99 -5q-30 0 -47.5 17.5t-17.5 46.5v11t2 12l138 648h34l-137 -641q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -22 13.5 -34t37.5 -12q11 0 26 2.5t28 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 553,
    d: "M268 651l76 79h44l-99 -92zM181 710h35l-145 -678h413l-7 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 228,
    d: "M244 651l76 79h44l-99 -92zM99 -5q-30 0 -47.5 17.5t-17.5 46.5v11t2 12l138 648h34l-137 -641q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -22 13.5 -34t37.5 -12q11 0 26 2.5t28 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 553,
    d: "M181 710h35l-145 -678h413l-7 -32h-447zM333 357l19 91h31l-19 -91h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 257,
    d: "M99 -5q-30 0 -47.5 17.5t-17.5 46.5v11t2 12l138 648h34l-137 -641q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -22 13.5 -34t37.5 -12q11 0 26 2.5t28 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4zM203 254l19 91h31l-19 -91h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 561,
    d: "M16 246l90 74l83 390h35l-76 -356l204 167l11 -22l-224 -184l-60 -283h413l-7 -32h-447l60 281l-71 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 251,
    d: "M20 321l100 81l70 328h34l-63 -295l104 84l13 -21l-125 -101l-65 -304q-3 -12 -3 -21q0 -22 13.5 -34t37.5 -12q11 0 25.5 2.5t28.5 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4q-31 0 -48.5 17t-17.5 46q0 12 3 24l60 282l-80 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 742,
    d: "M478 826l-21 13l76 79h44zM181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 546,
    d: "M352 638l-21 13l76 79h44zM125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 742,
    d: "M258 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 546,
    d: "M161 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68 l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 742,
    d: "M397 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 546,
    d: "M259 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68 l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 546,
    d: "M-41 651l49 51l7 28h64l-99 -92zM125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 742,
    d: "M412 -173q-29 0 -52 7.5t-39 27.5l25 22q14 -15 32.5 -20t38.5 -5q19 0 39 8.5t37 23t30.5 34t18.5 42.5l7 33l-347 644l-137 -644h-35l151 710h26l353 -654l139 653h34l-157 -742q-7 -31 -24 -56.5t-40 -44t-49.5 -29t-50.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 546,
    d: "M239 -173q-29 0 -52.5 7.5t-39.5 27.5l26 22q13 -15 31.5 -20t38.5 -5q18 0 38 8.5t37.5 23t30.5 34t18 42.5l69 323q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34l110 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10 q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-69 -326q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 725,
    d: "M348 867l5 28h269l-6 -28h-268zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139 q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 564,
    d: "M228 679l5 28h269l-6 -28h-268zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107 q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 725,
    d: "M297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5 t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5zM474 856q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12 q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 564,
    d: "M216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41 t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15zM355 668q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35 t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 725,
    d: "M399 826l-18 13l75 79h41zM503 826l-19 13l75 79h42zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35 t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 564,
    d: "M275 638l-18 13l75 79h41zM379 638l-19 13l75 79h42zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23 t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1134,
    d: "M300 -5q-60 0 -106.5 24.5t-78.5 65t-48.5 93.5t-16.5 110q0 81 34 158t90 137t128 96t149 36q51 0 91.5 -17.5t70 -48t47.5 -71.5t24 -87l46 219h437l-8 -32h-401l-63 -299h350l-8 -32h-350l-66 -315h409l-6 -32h-445l47 218q-26 -47 -62 -87.5t-78.5 -70.5t-90 -47.5 t-95.5 -17.5zM305 28q72 0 137 35t113.5 90.5t77.5 125.5t29 139q0 53 -15 101t-43 84t-68 57.5t-91 21.5q-72 0 -137.5 -35t-115 -90.5t-78.5 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 996,
    d: "M215 -10q-42 0 -76.5 16.5t-59 45.5t-38 68.5t-13.5 84.5q0 65 26 123.5t68.5 103t97.5 70.5t112 26q38 0 70 -13.5t55.5 -37.5t37.5 -58.5t16 -76.5q20 43 48.5 77.5t62 58.5t72 37t79.5 13q88 0 137 -60t49 -162q0 -32 -2.5 -44t-5.5 -17h-441q-3 -21 -3 -38 q0 -40 12.5 -74.5t35 -59.5t54 -39.5t69.5 -14.5q28 0 56 7.5t53.5 21.5t46.5 33.5t35 42.5l29 -8q-17 -28 -43 -51t-56.5 -39.5t-63.5 -26t-66 -9.5q-38 0 -71.5 13.5t-59 38.5t-41.5 59t-20 75q-22 -42 -51.5 -76.5t-63.5 -59t-71.5 -37.5t-75.5 -13zM222 22q49 0 96 23 t84 62t59.5 90.5t22.5 108.5q0 40 -11.5 75t-32.5 60.5t-50 40t-65 14.5q-48 0 -95 -23.5t-84 -63t-60 -91.5t-23 -109q0 -40 11.5 -74t32 -59t50 -39.5t65.5 -14.5zM924 272q3 22 3 45q0 40 -11.5 73.5t-32.5 57.5t-51 37t-66 13q-42 0 -81.5 -17t-73 -47t-58.5 -71.5 t-38 -90.5h409z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 619,
    d: "M396 828l-21 13l76 79h44zM30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78q0 30 -9 57.5t-25.5 48.5 t-39.5 33.5t-51 12.5h-242l-79 -372h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 325,
    d: "M232 638l-21 13l76 79h44zM125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 619,
    d: "M194 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78 q0 30 -9 57.5t-25.5 48.5t-39.5 33.5t-51 12.5h-242l-79 -372h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 325,
    d: "M-27 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 619,
    d: "M335 906l25 14l68 -63l94 63l19 -14l-107 -78h-26zM30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78 q0 30 -9 57.5t-25.5 48.5t-39.5 33.5t-51 12.5h-242l-79 -372h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 325,
    d: "M157 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 581,
    d: "M396 846l-21 13l76 79h44zM239 -5q-158 0 -242 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5q0 54 21 96.5t59 72t89.5 45t113.5 15.5q66 0 111.5 -20t76.5 -64 l-24 -26q-28 43 -68.5 60.5t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -52 -20.5 -92.5t-58 -68t-89 -42t-114.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 455,
    d: "M291 638l-21 13l76 79h44zM163 -10q-57 0 -102.5 20t-74.5 62l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5q0 43 18 76t47.5 54.5t68 32.5t79.5 11q59 0 97.5 -21 t52.5 -53l-25 -17q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16.5 -70t-46 -55t-70 -36t-88.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 581,
    d: "M318 861l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM239 -5q-158 0 -242 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5q0 54 21 96.5t59 72t89.5 45t113.5 15.5 q66 0 111.5 -20t76.5 -64l-24 -26q-28 43 -68.5 60.5t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -52 -20.5 -92.5t-58 -68t-89 -42t-114.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 455,
    d: "M211 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM163 -10q-57 0 -102.5 20t-74.5 62l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5q0 43 18 76t47.5 54.5t68 32.5 t79.5 11q59 0 97.5 -21t52.5 -53l-25 -17q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16.5 -70t-46 -55t-70 -36t-88.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 582,
    d: "M149 -125q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l59 79q-152 3 -233 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5 q0 54 21 96.5t59 72t89.5 45t113.5 15.5q66 0 111.5 -20t76.5 -64l-24 -26q-28 43 -68.5 60.5t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -50 -19 -89 t-53.5 -67t-83 -43t-107.5 -17l-39 -51q10 4 21 5t19 1q56 0 56 -44q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 455,
    d: "M65 -125q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l56 75q-51 3 -92 23t-67 58l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5 q0 43 18 76t47.5 54.5t68 32.5t79.5 11q59 0 97.5 -21t52.5 -53l-25 -17q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16 -69t-44.5 -54t-67 -36.5t-84.5 -14.5 l-35 -45q10 4 21 5t19 1q56 0 56 -44q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 581,
    d: "M327 924l25 14l68 -63l94 63l19 -14l-107 -78h-26zM239 -5q-158 0 -242 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5q0 54 21 96.5t59 72t89.5 45t113.5 15.5 q66 0 111.5 -20t76.5 -64l-24 -26q-28 43 -68.5 60.5t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -52 -20.5 -92.5t-58 -68t-89 -42t-114.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 455,
    d: "M213 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM163 -10q-57 0 -102.5 20t-74.5 62l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5q0 43 18 76t47.5 54.5t68 32.5 t79.5 11q59 0 97.5 -21t52.5 -53l-25 -17q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16.5 -70t-46 -55t-70 -36t-88.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 575,
    d: "M347 678h-252l6 32h539l-6 -32h-253l-144 -678h-4l-42 -55q10 4 21 5t19 1q56 0 56 -44q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5l16 22q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l64 84h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 293,
    d: "M25 -125q13 -7 34 -12.5t45 -5.5q65 0 65 46q0 16 -11.5 22t-28.5 6q-20 0 -43 -5t-37 -10l60 80q-27 4 -44 21t-17 44q0 5 0.5 10t1.5 10l87 409h-70l6 30h71l38 179h34l-38 -179h117l-7 -30h-117l-78 -363q-5 -23 -7 -34t-2 -17q0 -24 15.5 -36.5t37.5 -12.5 q15 0 29.5 3.5t26 8t19 8.5t9.5 5l6 -28q-2 -2 -10 -6t-20 -8.5t-27.5 -8.5t-33.5 -5l-39 -51q10 4 21 5t19 1q56 0 56 -44q0 -36 -25.5 -54.5t-72.5 -18.5q-26 0 -47.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 576,
    d: "M304 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM348 678h-252l6 32h539l-6 -32h-253l-144 -678h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 293,
    d: "M273 651l76 79h44l-99 -92zM124 -5q-33 0 -54.5 17.5t-21.5 48.5q0 5 0.5 10t1.5 10l87 409h-70l6 30h71l38 179h34l-38 -179h117l-7 -30h-117l-78 -363q-5 -23 -7 -34t-2 -17q0 -24 15.5 -36.5t37.5 -12.5q15 0 29.5 3.5t26 8t19 8.5t9.5 5l6 -28q-2 -2 -11 -6.5 t-23 -9.5t-32 -9t-37 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 616,
    d: "M90 418h224l55 260h-253l7 32h540l-8 -32h-252l-55 -260h223l-5 -25h-224l-83 -393h-34l83 393h-223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 294,
    d: "M39 357h70l29 133h-70l6 30h70l39 179h34l-39 -179h117l-6 -30h-117l-29 -133h118l-6 -27h-118l-44 -208q-4 -17 -6 -27.5t-2 -18.5q0 -25 15 -37t38 -12q15 0 29.5 3.5t26 8t19 8.5t9.5 5l6 -28q-2 -2 -11 -6.5t-23 -9.5t-32 -9t-37 -4q-33 0 -54.5 17.5t-21.5 48.5 q0 5 0.5 10t1.5 10l53 249h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5zM530 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23 t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5zM396 656q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25 q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5zM344 867l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5zM208 679l5 28h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5zM472 856q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5zM335 668q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 724,
    d: "M418 847q0 30 22.5 50.5t51.5 20.5q22 0 34.5 -13.5t12.5 -34.5q0 -29 -22 -50t-51 -21q-22 0 -35 13.5t-13 34.5zM487 899q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5q17 0 33 14t16 34q0 15 -9 24t-23 9zM298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74 t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 556,
    d: "M282 659q0 30 22.5 50.5t51.5 20.5q22 0 34.5 -13.5t12.5 -34.5q0 -29 -22 -50t-51 -21q-22 0 -35 13.5t-13 34.5zM351 711q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5q17 0 33 14t16 34q0 15 -9 24t-23 9zM165 -10q-121 0 -121 138q0 42 12 96l63 296h34 l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5zM397 826l-18 13l75 79h41zM501 826l-19 13l75 79h42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5zM257 638l-18 13l75 79h41zM361 638l-19 13l75 79h42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 724,
    d: "M232 -167q-22 6 -33 20t-11 33q0 27 20 52t69 58q-55 3 -92.5 22t-60.5 50t-33 72t-10 87q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356 q-15 -69 -42 -133t-69 -113t-99 -79.5t-131 -32.5q-28 -17 -46.5 -30.5t-29.5 -25.5t-15.5 -23.5t-4.5 -23.5q0 -30 36 -37l-19 -23v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37 l-19 -23q-22 6 -33 20t-11 33q0 29 22 55t77 61q-12 7 -12 26q0 2 0.5 5.5t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 989,
    d: "M502 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM99 710h38l128 -669l229 370l-58 293h35l49 -262l161 262h35l-183 -293l74 -370l411 669h38l-442 -710h-33l-74 378l-235 -378h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 732,
    d: "M337 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63zM59 520h35l87 -482q53 58 96 123.5t78 131.5l-45 227h35l34 -180q23 48 40.5 93t31.5 87h33q-35 -114 -95 -229l48 -253q49 55 90.5 116.5t75 124.5t59 124t43.5 117h33q-41 -131 -111.5 -263t-181.5 -257h-34l-47 247 q-35 -63 -78.5 -125t-97.5 -122h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 598,
    d: "M271 274l-176 436h39l162 -403l334 403h38l-363 -438l-58 -272h-34zM306 841l106 77h26l74 -77l-25 -15l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 468,
    d: "M-37 -196q31 6 52.5 15t39.5 24.5t35 39t39 56.5l38 59l-115 522h36l104 -484l53 85q46 73 78 128t54 100t37 85.5t28 85.5h34q-14 -48 -29 -89.5t-38 -88t-56.5 -103.5t-83.5 -136l-81 -129q-35 -56 -62 -92.5t-51.5 -58.5t-49.5 -32.5t-58 -14.5zM194 653l106 77h26 l74 -77l-25 -15l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 598,
    d: "M271 274l-176 436h39l162 -403l334 403h38l-363 -438l-58 -272h-34zM329 835l17 82h31l-17 -82h-31zM449 835l17 82h31l-17 -82h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 590,
    d: "M379 826l-21 13l76 79h44zM-33 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 460,
    d: "M276 638l-21 13l76 79h44zM-30 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 590,
    d: "M-33 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535zM390 835l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 460,
    d: "M-30 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399zM286 647l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 590,
    d: "M315 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM-33 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 460,
    d: "M211 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM-30 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 707,
    d: "M281 -9q-56 0 -102 20.5t-79 57.5t-51 87t-18 110q0 28 4 53.5t11 48.5h589q2 15 3 29t1 30q0 55 -15.5 102t-44 80.5t-68.5 52.5t-89 19q-37 0 -74.5 -11t-72 -30.5t-64 -47t-49.5 -61.5l-30 15q22 36 55.5 67t73.5 53.5t83.5 35.5t85.5 13q56 0 102 -23t78.5 -63 t50 -94t17.5 -115q0 -87 -34 -165t-89.5 -136.5t-127 -93t-146.5 -34.5zM285 25q59 0 114.5 24t102 65.5t79.5 98t47 122.5h-553q-4 -17 -6 -34.5t-2 -35.5q0 -46 13 -89t40 -76.5t68 -54t97 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 492,
    d: "M29 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l98 462h-70l6 30h71l17 80q20 95 67 148t111 53q27 0 51 -9.5t36 -24.5l-22 -22q-9 11 -27.5 18t-39.5 7q-52 0 -88.5 -43.5t-53.5 -126.5l-17 -80h143l-6 -30h-144 l-98 -462q-7 -31 -24 -56.5t-40 -44t-49 -29t-50 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1275,
    d: "M1000 904l25 14l68 -63l94 63l19 -14l-107 -78h-26zM653 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535zM181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5 t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1145,
    d: "M897 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM656 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399zM181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5 t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1044,
    d: "M796 716l25 14l68 -63l94 63l19 -14l-107 -78h-26zM555 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399zM216 -10q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102t93.5 71.5t110 27q33 0 60 -10t48.5 -27.5t37 -40.5t24.5 -48l69 328 h35l-144 -674q-1 -3 -1 -5.5v-4.5q0 -14 14 -14l-7 -32q-12 0 -16 1q-13 2 -19 11t-6 20q0 2 0.5 5t2 10.5t4 21.5t7.5 37q-42 -52 -100 -84t-114 -32zM227 22q27 0 61 12t65 32.5t55.5 48t33.5 57.5l38 179q-4 30 -19 56.5t-37 46t-49 31t-56 11.5q-52 0 -98.5 -25 t-81 -65.5t-55 -90.5t-20.5 -100q0 -39 11.5 -74.5t33 -61.5t51.5 -41.5t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1014,
    d: "M657 -11q-85 0 -137 44l18 28q44 -39 125 -39q58 0 96.5 22t65.5 64t45 103t35 138l77 360h34l-77 -360q-17 -81 -37.5 -147.5t-52 -113.5t-77.5 -73t-115 -26zM181 710h35l-145 -678h413l-7 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 752,
    d: "M439 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l117 553h34l-117 -552q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5zM730 730h34l-18 -84h-34zM181 710h35l-145 -678h413l-7 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 434,
    d: "M122 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l117 553h34l-117 -552q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5zM413 730h34l-18 -84h-34zM99 -5q-30 0 -47.5 17.5t-17.5 46.5v11t2 12l138 648h34l-137 -641 q-1 -5 -1.5 -8.5t-0.5 -8.5q0 -22 13.5 -34t37.5 -12q11 0 26 2.5t28 7.5l2 -28q-16 -5 -38.5 -9t-38.5 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1203,
    d: "M846 -11q-85 0 -137 44l18 28q44 -39 125 -39q58 0 96.5 22t65.5 64t45 103t35 138l77 360h34l-77 -360q-17 -81 -37.5 -147.5t-52 -113.5t-77.5 -73t-115 -26zM181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 941,
    d: "M628 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l117 553h34l-117 -552q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5zM919 730h34l-18 -84h-34zM181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 744,
    d: "M432 -173q-29 0 -52.5 7.5t-38.5 27.5l25 22q13 -15 32 -20t38 -5t39 8.5t37.5 23t30.5 34t18 42.5l117 553h34l-117 -552q-7 -31 -24 -57t-40 -44.5t-49 -29t-50 -10.5zM723 730h34l-18 -84h-34zM125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10 q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 725,
    d: "M233 -167q-22 6 -33 20t-11 33q0 27 20 52t69 58q-55 4 -97.5 29.5t-71.5 65.5t-44 90.5t-15 105.5q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -80 -32 -155t-85.5 -134t-123 -96t-144.5 -40q-28 -17 -46.5 -30.5t-29.5 -25.5 t-15.5 -23.5t-4.5 -23.5q0 -30 36 -37zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 564,
    d: "M162 -172q-22 6 -33 20t-11 33q0 27 20 52t68 57q-41 2 -74 20t-56 47t-35.5 67.5t-12.5 82.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -59 -22.5 -113.5t-61 -97.5t-88 -71.5t-103.5 -34.5q-29 -18 -47.5 -31.5t-30 -25.5 t-16 -23.5t-4.5 -23.5q0 -30 36 -37zM222 22q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1264,
    d: "M641 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535zM181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5 t-98.5 18h-186l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1145,
    d: "M656 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399zM181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5 t-98.5 18h-186l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1044,
    d: "M555 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399zM216 -10q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102t93.5 71.5t110 27q33 0 60 -10t48.5 -27.5t37 -40.5t24.5 -48l69 328h35l-144 -674q-1 -3 -1 -5.5v-4.5q0 -14 14 -14 l-7 -32q-12 0 -16 1q-13 2 -19 11t-6 20q0 2 0.5 5t2 10.5t4 21.5t7.5 37q-42 -52 -100 -84t-114 -32zM227 22q27 0 61 12t65 32.5t55.5 48t33.5 57.5l38 179q-4 30 -19 56.5t-37 46t-49 31t-56 11.5q-52 0 -98.5 -25t-81 -65.5t-55 -90.5t-20.5 -100q0 -39 11.5 -74.5 t33 -61.5t51.5 -41.5t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 688,
    d: "M456 826l-21 13l76 79h44zM559 116q-125 -121 -259 -121q-60 0 -106 25t-78 66.5t-48.5 95t-16.5 110.5q0 78 32.5 154t87 135.5t125.5 96.5t148 37q51 0 89.5 -11.5t65.5 -32t44 -49t26 -62.5l-33 -15q-21 73 -72.5 105t-127.5 32q-72 0 -136 -35t-112 -90.5t-75.5 -125 t-27.5 -137.5q0 -54 16 -102.5t45 -84.5t70 -57.5t92 -21.5q64 0 127.5 31t132.5 98l33 154h-155l6 30h187l-73 -341h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 581,
    d: "M320 638l-21 13l76 79h44zM166 -223q-44 0 -76 9t-54.5 25t-37 38.5t-23.5 49.5l28 14q18 -56 63.5 -81t105.5 -25q39 0 76 11t67.5 33.5t53 55.5t31.5 77l27 122q-42 -51 -100 -83t-114 -32q-44 0 -78 18t-58 48.5t-36.5 70t-12.5 82.5q0 59 24 116t64 102t93 72.5 t112 27.5q33 0 59.5 -10t47 -27t36.5 -40t28 -49l25 118h31l-114 -536q-11 -53 -38 -92t-63 -64.5t-79.5 -38t-87.5 -12.5zM226 22q33 0 67.5 13.5t64.5 35t52 48t31 53.5l38 179q-5 31 -19 58t-36 46t-49 30t-57 11q-54 0 -100.5 -26t-81 -67t-54 -91t-19.5 -97 q0 -39 11.5 -74t33 -61.5t51.5 -42t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 649,
    d: "M364 739q0 30 22.5 50.5t51.5 20.5q22 0 34.5 -13.5t12.5 -34.5q0 -24 -15 -42.5t-37 -25.5l135 -694h-37l-47 245h-336l-151 -245h-38l432 695q-27 11 -27 44zM480 275l-74 391l-242 -391h316zM433 791q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5q17 0 33 14 t16 34q0 15 -9 24t-23 9zM426 827l-21 13l76 78h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM364 777l-21 13l76 79h44zM302 659 q0 30 22.5 50.5t51.5 20.5q22 0 34.5 -13.5t12.5 -34.5q0 -29 -22 -50t-51 -21q-22 0 -35 13.5t-13 34.5zM371 711q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5q17 0 33 14t16 34q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 922,
    d: "M544 826l-21 13l76 79h44zM509 710h445l-7 -32h-402l-63 -299h350l-7 -32h-350l-67 -315h410l-7 -32h-444l52 245h-260l-202 -245h-40zM425 277l81 386l-322 -386h241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 884,
    d: "M479 638l-21 13l76 79h44zM136 -10q-34 0 -59.5 10.5t-42.5 28.5t-25.5 41.5t-8.5 50.5q0 40 18.5 73t51 56.5t76.5 36.5t95 13q33 0 66.5 -5.5t62.5 -14.5q7 26 18 50t22 47q0 55 -32 88.5t-89 33.5q-39 0 -83 -16.5t-92 -47.5l-10 25q56 35 102.5 51.5t90.5 16.5 q58 0 96 -30.5t46 -87.5q42 53 99.5 85.5t120.5 32.5q42 0 77.5 -15.5t61 -43t40 -64.5t14.5 -80q0 -21 -3.5 -43.5t-9.5 -36.5h-443q-3 -21 -3 -40q0 -40 11.5 -74t33 -59t52 -39t67.5 -14q27 0 55 7.5t53 21.5t46 33.5t36 42.5l29 -8q-16 -27 -41 -50.5t-55 -40t-64 -26 t-67 -9.5q-63 0 -108 32.5t-66 86.5q-22 -32 -53 -55t-64 -37t-65 -20.5t-57 -6.5zM148 19q30 0 64.5 9t65 25.5t54.5 39t33 48.5q-7 24 -7 56q0 27 6 56q-29 11 -61 16t-63 5q-45 0 -83 -10.5t-65.5 -29.5t-43 -46.5t-15.5 -60.5q0 -21 6.5 -40.5t21 -34.5t36 -24t51.5 -9z M812 272q6 25 6 52q0 35 -10.5 66.5t-31 55.5t-51.5 38t-71 14q-42 0 -82 -17t-74 -47t-59 -71.5t-38 -90.5h411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 725,
    d: "M690 710l-64 -77q35 -42 53 -97t18 -115q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36q-47 0 -85.5 15t-67.5 42l-43 -52h-40l61 74q-35 42 -53.5 97t-18.5 116q0 82 34 159t90 137t128 96t149 36q47 0 85.5 -16t68.5 -44l45 55h40zM85 291q0 -55 15.5 -103.5 t45.5 -85.5l436 526q-27 25 -61.5 39.5t-76.5 14.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 54 -15.5 102t-44.5 85l-436 -525q27 -25 61.5 -38.5t76.5 -13.5zM459 826l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 564,
    d: "M86 46q-28 30 -43 71.5t-15 89.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q33 0 61.5 -10.5t51.5 -30.5l28 33h31l-42 -50q27 -30 42 -71.5t15 -89.5q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-111.5 -26.5q-34 0 -62.5 10.5t-51.5 29.5l-26 -30h-31zM63 211 q0 -42 12 -77t35 -61l311 386q-20 17 -44.5 27t-52.5 10q-48 0 -94.5 -23.5t-83.5 -63t-60 -91t-23 -107.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 41 -12 77t-35 62l-312 -385q41 -36 97 -36zM350 638l-21 13l76 79h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM442 918h41l43 -79l-26 -13zM339 918h41l42 -79l-24 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM356 730h41l43 -79l-26 -13zM253 730h41 l42 -79l-24 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 648,
    d: "M400 710h30l138 -710h-37l-47 245h-336l-151 -245h-38zM480 275l-74 391l-242 -391h316zM368 834q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    d: "M214 -10q-43 0 -77.5 18t-58.5 48.5t-36.5 70t-12.5 82.5q0 61 24 118.5t64.5 102t93 71.5t108.5 27q34 0 61.5 -10t49 -27.5t37 -40.5t24.5 -48l25 118h35l-99 -463q-2 -6 -2 -12q0 -13 14 -13l-7 -32q-2 0 -5 -0.5t-5 -0.5q-16 0 -23.5 9.5t-7.5 22.5q0 3 0.5 6.5t2 11 t4 21t7.5 36.5q-42 -52 -100 -84t-116 -32zM224 22q30 0 64 12t65.5 33t55.5 48t33 57l38 179q-4 29 -18 55t-36 46t-50 32t-61 12q-50 0 -95.5 -25.5t-80 -66t-55 -91t-20.5 -101.5q0 -38 12 -72.5t33 -60.5t50.5 -41.5t64.5 -15.5zM281 646q3 16 12 31.5t21.5 27t28 18.5 t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 586,
    d: "M416 918h41l43 -79l-26 -13zM313 918h41l42 -79l-24 -13zM181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 525,
    d: "M345 730h41l43 -79l-26 -13zM242 730h41l42 -79l-24 -13zM222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61 t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5 t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 586,
    d: "M352 834q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 525,
    d: "M284 646q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26 t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5 t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM225 918h41l43 -79l-26 -13zM122 918h41l42 -79l-24 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 191,
    d: "M158 730h41l43 -79l-26 -13zM55 730h41l42 -79l-24 -13zM125 520h34l-110 -520h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM151 834q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 191,
    d: "M93 646q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM125 520h34l-110 -520h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 725,
    d: "M486 918h41l43 -79l-26 -13zM383 918h41l42 -79l-24 -13zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35 t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 564,
    d: "M367 730h41l43 -79l-26 -13zM264 730h41l42 -79l-24 -13zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22 q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 725,
    d: "M404 834q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66 t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 564,
    d: "M281 646q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47 t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 619,
    d: "M422 918h41l43 -79l-26 -13zM319 918h41l42 -79l-24 -13zM30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78 q0 30 -9 57.5t-25.5 48.5t-39.5 33.5t-51 12.5h-242l-79 -372h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 325,
    d: "M249 730h41l43 -79l-26 -13zM146 730h41l42 -79l-24 -13zM125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 619,
    d: "M350 834q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5 l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78q0 30 -9 57.5t-25.5 48.5t-39.5 33.5t-51 12.5h-242l-79 -372h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 325,
    d: "M172 649q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327 h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 724,
    d: "M477 918h41l43 -79l-26 -13zM374 918h41l42 -79l-24 -13zM298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5 l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 556,
    d: "M348 730h41l43 -79l-26 -13zM245 730h41l42 -79l-24 -13zM165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1 q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 724,
    d: "M399 834q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5 q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5t-102.5 -79t-137 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 556,
    d: "M267 646q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25zM165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5 t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 581,
    d: "M183 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM239 -5q-158 0 -242 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5q0 54 21 96.5t59 72t89.5 45t113.5 15.5 q66 0 111.5 -20t76.5 -64l-24 -26q-28 43 -68.5 60.5t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -52 -20.5 -92.5t-58 -68t-89 -42t-114.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 455,
    d: "M115 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM163 -10q-57 0 -102.5 20t-74.5 62l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5q0 43 18 76t47.5 54.5t68 32.5 t79.5 11q59 0 97.5 -21t52.5 -53l-25 -17q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16.5 -70t-46 -55t-70 -36t-88.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 576,
    d: "M164 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM348 678h-252l6 32h539l-6 -32h-253l-144 -678h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 293,
    d: "M67 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20zM124 -5q-33 0 -54.5 17.5t-21.5 48.5q0 5 0.5 10t1.5 10l87 409h-70l6 30h71l38 179h34l-38 -179h117l-7 -30h-117l-78 -363q-5 -23 -7 -34t-2 -17q0 -24 15.5 -36.5t37.5 -12.5q15 0 29.5 3.5t26 8t19 8.5t9.5 5l6 -28 q-2 -2 -11 -6.5t-23 -9.5t-32 -9t-37 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 191,
    d: "M-121 -173q-29 0 -53 7.5t-39 27.5l25 22q13 -15 32 -20t39 -5q18 0 38 8.5t37.5 23t30.5 34t18 42.5l118 553h34l-118 -552q-6 -31 -23.5 -57t-40 -44.5t-48.5 -29t-50 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 552,
    d: "M205 -10q-43 0 -78 15.5t-60 43t-38.5 65t-13.5 81.5q0 18 1.5 39.5t8.5 38.5h442q3 21 3 40q0 40 -12 74t-33 59t-51 38.5t-66 13.5q-27 0 -55 -7.5t-53.5 -21.5t-46.5 -33t-36 -42l-28 8q16 27 40.5 50t55 40t64 26.5t67.5 9.5q43 0 77.5 -17t59.5 -47t38.5 -70.5 t13.5 -86.5q0 -63 -25 -120.5t-67 -101t-96 -69.5t-112 -26zM211 19q41 0 80.5 17t73 47.5t59 72t37.5 90.5h-408q-3 -24 -3 -45q0 -41 11.5 -74.5t32.5 -57.5t50.5 -37t66.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 538,
    d: "M297 651l49 51l7 28h64l-99 -92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 296,
    d: "M51 653l106 77h26l74 -77l-25 -15l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 296,
    d: "M54 716l25 14l68 -63l94 63l19 -14l-107 -78h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 366,
    d: "M59 707h269l-6 -28h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 246,
    d: "M117 668q20 0 39.5 18t27.5 44h24q-4 -17 -13.5 -32.5t-22.5 -27t-28.5 -18t-30.5 -6.5q-28 0 -45.5 19t-17.5 48q0 5 0.5 8.5t1.5 8.5h26q-2 -8 -2 -12q0 -20 11.5 -35t29.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 126,
    d: "M42 647l18 83h32l-17 -83h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 229,
    d: "M60 659q0 30 22.5 50.5t51.5 20.5q22 0 34.5 -13.5t12.5 -34.5q0 -29 -22 -50t-51 -21q-22 0 -35 13.5t-13 34.5zM129 711q-18 0 -33 -13.5t-15 -34.5q0 -14 8.5 -23.5t22.5 -9.5q17 0 33 14t16 34q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 204,
    d: "M69 -164q-22 6 -33 20t-11 33q0 30 25.5 58t88.5 68l12 -15q-29 -18 -48 -31.5t-30.5 -25.5t-16 -23.5t-4.5 -23.5q0 -30 36 -37l-19 -23v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 371,
    d: "M238 656q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 292,
    d: "M59 638l-18 13l75 79h41zM163 638l-19 13l75 79h42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 292,
    d: "M160 730h41l43 -79l-26 -13zM57 730h41l42 -79l-24 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 246,
    d: "M49 646q3 16 12 31.5t21.5 27t28 18.5t33.5 7q31 0 46.5 -20.5t15.5 -46.5v-8.5t-1 -8.5h-25q2 10 2 15q0 47 -41 47q-26 0 -44 -19t-23 -43h-25v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 618,
    d: "M-23 30l286 680h29l285 -680v-30h-600v30zM539 32l-261 634l-263 -634h524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 816,
    d: "M61 33h210q-48 22 -86 57t-64 78.5t-40 93.5t-14 103q0 69 25 132.5t69 111.5t104.5 77t131.5 29t131.5 -29t104.5 -77t69 -111.5t25 -132.5q0 -53 -14 -103t-40.5 -93.5t-64.5 -78.5t-86 -57h211v-33h-289v33q60 13 106 47t77.5 80t47.5 99.5t16 105.5q0 59 -20.5 115.5 t-58.5 101t-92.5 72t-122.5 27.5q-69 0 -123.5 -27.5t-92.5 -72t-58.5 -101t-20.5 -115.5q0 -52 16 -105.5t47.5 -99.5t78 -80t106.5 -47v-33h-289v33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 563,
    d: "M125 520h34l-62 -292q-11 -50 -11 -84q0 -63 22.5 -92.5t76.5 -29.5q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h35l-99 -466q-1 -3 -1 -8q0 -14 14 -14l-8 -32q-17 0 -28 8.5t-11 31.5q0 2 2.5 14.5l5.5 27.5t6 28.5t4 17.5q-22 -31 -49.5 -56.5t-58.5 -43.5 t-63.5 -28t-64.5 -10q-50 0 -77.5 25t-33.5 73l-63 -300h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 636,
    d: "M485 -5q-38 0 -61 23.5t-23 63.5v405h-233v-487h-33v487h-80v33h489v-33h-110v-398q0 -29 17.5 -46t47.5 -17q11 0 26 2.5t28 7.5l9 -28q-15 -5 -38 -9t-39 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 686,
    d: "M216 -138l17 83h32l-17 -83h-32zM181 710h221q65 0 113 -21t79.5 -57.5t46.5 -86t15 -106.5q0 -94 -30.5 -174.5t-84.5 -139t-128 -92t-162 -33.5h-221zM258 32q85 0 152 33t114 88.5t72 128t25 151.5q0 54 -14 99t-42.5 77.5t-71 50.5t-98.5 18h-186l-138 -646h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    d: "M180 -138l17 83h32l-17 -83h-32zM216 -10q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102t93.5 71.5t110 27q33 0 60 -10t48.5 -27.5t37 -40.5t24.5 -48l69 328h35l-144 -674q-1 -3 -1 -5.5v-4.5q0 -14 14 -14l-7 -32q-12 0 -16 1q-13 2 -19 11 t-6 20q0 2 0.5 5t2 10.5t4 21.5t7.5 37q-42 -52 -100 -84t-114 -32zM227 22q27 0 61 12t65 32.5t55.5 48t33.5 57.5l38 179q-4 30 -19 56.5t-37 46t-49 31t-56 11.5q-52 0 -98.5 -25t-81 -65.5t-55 -90.5t-20.5 -100q0 -39 11.5 -74.5t33 -61.5t51.5 -41.5t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 703,
    d: "M181 710h35l-71 -331h446l71 331h34l-151 -710h-34l74 347h-447l-73 -347h-35zM243 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 546,
    d: "M170 730h34l-72 -340q22 31 49 56.5t57 43.5t62 28t64 10q60 0 89 -35t29 -102q0 -21 -2.5 -45.5t-8.5 -51.5l-62 -294h-34l61 290q11 53 11 89q0 117 -97 117q-32 0 -66 -13t-65.5 -36t-57.5 -54.5t-43 -67.5l-69 -325h-34zM175 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 742,
    d: "M476 835l18 83h32l-17 -83h-33zM181 710h27l354 -655l138 654h35l-151 -709h-33l-349 644l-137 -644h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 546,
    d: "M335 647l18 83h32l-17 -83h-33zM125 520h32l-27 -130q21 31 49.5 56.5t61 43.5t66.5 28t67 10q57 0 83.5 -31.5t26.5 -94.5q0 -23 -3.5 -50t-9.5 -58l-62 -294h-34l61 290q12 58 12 100q0 106 -88 106q-33 0 -68.5 -13t-68 -36t-60 -54t-45.5 -68l-69 -325h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 619,
    d: "M30 0l151 710h278q36 0 64 -15t47.5 -40t30 -57.5t10.5 -66.5q0 -45 -17 -88.5t-46.5 -78.5t-68.5 -58.5t-83 -27.5l109 -278h-40l-108 274h-234l-58 -274h-35zM379 306q41 0 77 20t62.5 51.5t42 70.5t15.5 78q0 30 -9 57.5t-25.5 48.5t-39.5 33.5t-51 12.5h-242 l-79 -372h249zM206 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 325,
    d: "M125 520h32l-27 -132q21 31 46 55.5t52 41.5t55 26t55 9q5 0 10 -1l-7 -31q-69 -3 -128.5 -45.5t-94.5 -115.5l-69 -327h-34zM-13 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 581,
    d: "M239 -5q-158 0 -242 108l25 25q73 -103 225 -103q108 0 172.5 45.5t64.5 132.5q0 29 -12 50t-35 37t-58.5 27.5t-81.5 22.5q-46 10 -82 21.5t-60.5 28t-37.5 40t-13 56.5q0 54 21 96.5t59 72t89.5 45t113.5 15.5q66 0 111.5 -20t76.5 -64l-24 -26q-28 43 -68.5 60.5 t-100.5 17.5q-64 0 -109.5 -14.5t-75 -39.5t-43 -59.5t-13.5 -73.5q0 -28 11 -47t32.5 -33t54.5 -24.5t78 -20.5q46 -11 83.5 -23t64.5 -30t41.5 -43.5t14.5 -62.5q0 -52 -20.5 -92.5t-58 -68t-89 -42t-114.5 -14.5zM194 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 455,
    d: "M163 -10q-57 0 -102.5 20t-74.5 62l23 23q32 -38 70 -57t90 -19q38 0 71 9.5t57 27.5t38 43t14 56q0 21 -9.5 35t-27.5 25t-44.5 19.5t-60.5 17.5q-33 9 -59 17t-43 19.5t-26 27t-9 38.5q0 43 18 76t47.5 54.5t68 32.5t79.5 11q59 0 97.5 -21t52.5 -53l-25 -17 q-14 30 -51.5 46t-83.5 16q-33 0 -63.5 -8t-54 -25t-37.5 -42.5t-14 -60.5q0 -36 29 -51t87 -30q38 -10 68.5 -20t51.5 -23t32.5 -31t11.5 -44q0 -38 -16.5 -70t-46 -55t-70 -36t-88.5 -13zM125 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 576,
    d: "M176 -138l17 83h32l-17 -83h-32zM348 678h-252l6 32h539l-6 -32h-253l-144 -678h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 293,
    d: "M74 -138l17 83h32l-17 -83h-32zM124 -5q-33 0 -54.5 17.5t-21.5 48.5q0 5 0.5 10t1.5 10l87 409h-70l6 30h71l38 179h34l-38 -179h117l-7 -30h-117l-78 -363q-5 -23 -7 -34t-2 -17q0 -24 15.5 -36.5t37.5 -12.5q15 0 29.5 3.5t26 8t19 8.5t9.5 5l6 -28q-2 -2 -11 -6.5 t-23 -9.5t-32 -9t-37 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 989,
    d: "M99 710h38l128 -669l229 370l-58 293h35l49 -262l161 262h35l-183 -293l74 -370l411 669h38l-442 -710h-33l-74 378l-235 -378h-33zM555 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 732,
    d: "M59 520h35l87 -482q53 58 96 123.5t78 131.5l-45 227h35l34 -180q23 48 40.5 93t31.5 87h33q-35 -114 -95 -229l48 -253q49 55 90.5 116.5t75 124.5t59 124t43.5 117h33q-41 -131 -111.5 -263t-181.5 -257h-34l-47 247q-35 -63 -78.5 -125t-97.5 -122h-34zM389 730h44 l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 989,
    d: "M587 826l-21 13l76 79h44zM99 710h38l128 -669l229 370l-58 293h35l49 -262l161 262h35l-183 -293l74 -370l411 669h38l-442 -710h-33l-74 378l-235 -378h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 732,
    d: "M418 638l-21 13l76 79h44zM59 520h35l87 -482q53 58 96 123.5t78 131.5l-45 227h35l34 -180q23 48 40.5 93t31.5 87h33q-35 -114 -95 -229l48 -253q49 55 90.5 116.5t75 124.5t59 124t43.5 117h33q-41 -131 -111.5 -263t-181.5 -257h-34l-47 247q-35 -63 -78.5 -125 t-97.5 -122h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 989,
    d: "M522 835l17 82h31l-17 -82h-31zM642 835l17 82h31l-17 -82h-31zM99 710h38l128 -669l229 370l-58 293h35l49 -262l161 262h35l-183 -293l74 -370l411 669h38l-442 -710h-33l-74 378l-235 -378h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 732,
    d: "M352 647l17 82h31l-17 -82h-31zM472 647l17 82h31l-17 -82h-31zM59 520h35l87 -482q53 58 96 123.5t78 131.5l-45 227h35l34 -180q23 48 40.5 93t31.5 87h33q-35 -114 -95 -229l48 -253q49 55 90.5 116.5t75 124.5t59 124t43.5 117h33q-41 -131 -111.5 -263t-181.5 -257 h-34l-47 247q-35 -63 -78.5 -125t-97.5 -122h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 590,
    d: "M-33 30l634 648h-490l7 32h532l-7 -30l-632 -648h492l-7 -32h-535zM188 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 460,
    d: "M-30 28l460 463h-356l6 29h396l-6 -28l-459 -463h359l-7 -29h-399zM123 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447zM207 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6zM176 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 586,
    d: "M181 710h438l-7 -32h-403l-64 -299h353l-7 -32h-353l-67 -315h412l-6 -32h-447zM477 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7 t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 525,
    d: "M222 -10q-46 0 -82 17.5t-60.5 47.5t-37.5 70t-13 85q0 60 23.5 117t64.5 102t97 72t121 27q28 0 56 -9t50.5 -26t36.5 -43t14 -60q0 -146 -267 -146q-35 0 -73 1t-85 4q-3 -20 -3 -38q0 -39 10.5 -74t31.5 -61t52 -41.5t72 -15.5q27 0 54.5 8t53 22.5t47.5 35t36 46.5 l30 -9q-17 -30 -42.5 -54t-55.5 -41.5t-63.5 -27t-67.5 -9.5zM330 498q-48 0 -90 -18.5t-75.5 -49t-57 -70.5t-34.5 -82q46 -3 83 -4t72 -1q64 0 108 8.5t71.5 24.5t39.5 37.5t12 47.5q0 28 -12 48.5t-30.5 33.5t-41.5 19t-45 6zM414 656q-21 0 -35.5 6t-26.5 13t-23 13 t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 223,
    d: "M181 709h35l-151 -709h-35zM2 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 191,
    d: "M125 520h34l-110 -520h-34zM170 730h34l-18 -84h-34zM-14 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 725,
    d: "M255 -138l17 83h32l-17 -83h-32zM297 -5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t149 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-89.5 -136.5t-128 -95.5t-148.5 -36zM305 28q72 0 137 35t114 90.5t78 125.5t29 139 q0 53 -15 101t-43.5 84t-69 57.5t-91.5 21.5q-72 0 -137.5 -35t-114.5 -90.5t-78 -125.5t-29 -140q0 -53 15 -100.5t43 -83.5t69 -57.5t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 564,
    d: "M173 -138l17 83h32l-17 -83h-32zM216 -10q-43 0 -78 17t-59.5 46.5t-37.5 69t-13 84.5q0 63 26 121.5t69 102.5t97 70.5t111 26.5q42 0 76.5 -17t59 -47t38 -70t13.5 -85q0 -62 -25.5 -120t-67.5 -102t-96.5 -70.5t-112.5 -26.5zM222 22q48 0 95 23t84 62t60 90t23 107 q0 40 -12 75t-33 61t-50.5 41t-64.5 15q-47 0 -94 -23.5t-84 -63t-60 -91t-23 -107.5q0 -39 11.5 -73.5t32.5 -60t50 -40.5t65 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102.5 18t-67 49.5t-36.5 74t-11 90.5q0 60 14 127l76 356h34l-75 -356q-7 -31 -11 -61.5t-4 -59.5q0 -43 9.5 -80.5t31.5 -65t58.5 -43.5t89.5 -16q72 0 125.5 28.5t91 74.5t61 104.5t36.5 118.5l75 356h34l-75 -356q-15 -71 -43 -136t-71.5 -114.5 t-102.5 -79t-137 -29.5zM253 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 556,
    d: "M165 -10q-121 0 -121 138q0 42 12 96l63 296h34l-62 -292q-12 -53 -12 -92q0 -114 100 -114q33 0 67.5 12.5t66 34.5t58.5 53t46 68l70 330h34l-94 -445q-2 -10 -4 -18t-2 -10q0 -15 15 -15l-8 -32q-12 0 -16 1q-23 4 -23 30q0 2 0.5 5.5t2 13.5t5 28t10.5 50 q-23 -32 -51 -57.5t-59.5 -43.5t-65 -27.5t-66.5 -9.5zM158 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 598,
    d: "M271 274l-176 436h39l162 -403l334 403h38l-363 -438l-58 -272h-34zM348 918h44l43 -79l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 468,
    d: "M-37 -196q31 6 52.5 15t39.5 24.5t35 39t39 56.5l38 59l-115 522h36l104 -484l53 85q46 73 78 128t54 100t37 85.5t28 85.5h34q-14 -48 -29 -89.5t-38 -88t-56.5 -103.5t-83.5 -136l-81 -129q-35 -56 -62 -92.5t-51.5 -58.5t-49.5 -32.5t-58 -14.5zM241 730h44l43 -79 l-27 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 598,
    d: "M271 274l-176 436h39l162 -403l334 403h38l-363 -438l-58 -272h-34zM450 844q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16 t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 468,
    d: "M-37 -196q31 6 52.5 15t39.5 24.5t35 39t39 56.5l38 59l-115 522h36l104 -484l53 85q46 73 78 128t54 100t37 85.5t28 85.5h34q-14 -48 -29 -89.5t-38 -88t-56.5 -103.5t-83.5 -136l-81 -129q-35 -56 -62 -92.5t-51.5 -58.5t-49.5 -32.5t-58 -14.5zM350 656 q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-25q0 3 5 15.5t16 25.5t28 23.5t42 10.5q19 0 32 -6t24.5 -13.5t24 -13.5t30.5 -6q19 0 31.5 7t20 15.5t11 16t3.5 9.5h25q-1 -4 -6 -16t-16.5 -25t-30 -23t-45.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 540
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 864
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 527,
    d: "M57 255l6 33h395l-7 -33h-394z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 845,
    d: "M57 255l6 33h712l-6 -33h-712z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 171,
    d: "M192 730l-31 -92h13l-17 -82h-38l18 82l35 92h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 167,
    d: "M121 556l31 92h-13l17 82h38l-18 -82l-35 -92h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 248,
    d: "M24 -84l29 84h-13l18 82h37l-18 -82l-33 -84h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 258,
    d: "M192 730l-31 -92h13l-17 -82h-38l18 82l35 92h20zM279 730l-31 -92h13l-17 -82h-38l18 82l36 92h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 255,
    d: "M121 556l31 92h-13l17 82h38l-18 -82l-35 -92h-20zM209 556l31 92h-13l16 82h38l-17 -82l-36 -92h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 330,
    d: "M24 -84l29 84h-13l18 82h37l-18 -82l-33 -84h-20zM105 -84l29 84h-13l18 82h38l-18 -82l-34 -84h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 369,
    d: "M77 -130l81 385h-125l7 32h126l104 488h33l-104 -488h124l-7 -32h-125l-81 -385h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 375,
    d: "M80 -130l67 319h-125l7 32h126l23 110h-125l7 33h125l87 411h33l-87 -411h125l-8 -33h-124l-23 -110h124l-7 -32h-125l-67 -319h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 334,
    d: "M255 358q0 -20 -8.5 -37t-22 -30.5t-31 -21t-35.5 -7.5q-28 0 -45.5 19t-17.5 48q0 19 8.5 36.5t22.5 30.5t31.5 21t35.5 8q28 0 45 -19.5t17 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 373,
    d: "M6 0l16 74h31l-16 -74h-31zM109 0l16 74h30l-15 -74h-31zM211 0l16 74h31l-16 -74h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 971,
    d: "M218 441q-50 0 -80 32.5t-30 80.5q0 33 14.5 63.5t38 53t53 36t60.5 13.5q51 0 80.5 -33t29.5 -81q0 -33 -14.5 -63t-38 -52.5t-53 -36t-60.5 -13.5zM224 466q24 0 47.5 11.5t42 30.5t30 43.5t11.5 50.5q0 39 -24.5 65.5t-62.5 26.5q-24 0 -47.5 -11.5t-42 -30t-29.5 -43 t-11 -51.5q0 -38 24 -65t62 -27zM418 -10q-51 0 -80.5 33t-29.5 81q0 33 14.5 63t37.5 52.5t53 36t61 13.5q50 0 79.5 -33t29.5 -81q0 -33 -14.5 -63t-37.5 -52.5t-52.5 -36t-60.5 -13.5zM423 16q24 0 47.5 11t42 30t30 43.5t11.5 50.5q0 38 -24 65.5t-62 27.5 q-24 0 -47.5 -11.5t-42 -30.5t-30 -43.5t-11.5 -51.5q0 -38 23.5 -64.5t62.5 -26.5zM739 -10q-50 0 -80 32.5t-30 81.5q0 33 14.5 63t38 52.5t53 36t60.5 13.5q51 0 80.5 -33t29.5 -81q0 -33 -14.5 -63t-38 -52.5t-53.5 -36t-60 -13.5zM744 16q25 0 48.5 11t42 30t30 43 t11.5 50q0 39 -24.5 66.5t-62.5 27.5q-24 0 -47.5 -11.5t-42 -30.5t-30 -43.5t-11.5 -51.5q0 -38 23.5 -64.5t62.5 -26.5zM-1 16l676 696l17 -17l-676 -697z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 335,
    d: "M36 270l265 172l-7 -33l-231 -150l167 -150l-7 -33l-192 171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 335,
    d: "M282 247l-265 -171l7 33l231 150l-167 150l7 33l191 -172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 130,
    d: "M-271 16l676 696l18 -17l-676 -697z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 426,
    d: "M238 417q-36 0 -61.5 14.5t-42 37.5t-24.5 51.5t-8 57.5q0 40 17 81t47 74.5t70 55t85 21.5q36 0 61.5 -14.5t42 -37.5t24 -51.5t7.5 -56.5q0 -40 -17 -81.5t-46.5 -75t-69 -55t-85.5 -21.5zM130 581q0 -26 7 -50.5t21 -43.5t35.5 -31t50.5 -12q41 0 75 20t58.5 50 t38 65.5t13.5 66.5q0 25 -7 50t-21.5 44.5t-35.5 31.5t-49 12q-42 0 -76 -20t-58.5 -50.5t-38 -66t-13.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 358,
    d: "M272 422l23 108h-220l6 25l281 255h19l-54 -254h53l-5 -26h-53l-23 -108h-27zM114 556h187l45 211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 354,
    d: "M254 667q52 0 84.5 -28t32.5 -73q0 -33 -15 -60t-39.5 -47t-56 -31t-64.5 -11q-45 0 -76.5 21t-42.5 56l23 11q11 -29 37.5 -46t65.5 -17q28 0 53 9t44.5 25t31 37.5t11.5 47.5q0 20 -8 35t-21.5 25.5t-31 16t-36.5 5.5q-31 0 -61.5 -13t-51.5 -35h-26q6 14 20.5 47 t30 68.5t28 64.5t14.5 35h204l-6 -26h-183l-67 -153q23 18 50 27t56 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 383,
    d: "M403 568q0 -32 -15 -60t-40 -49t-58 -33t-68 -12q-55 0 -88.5 33t-33.5 91q0 56 15.5 105.5t43.5 86.5t66.5 58.5t84.5 21.5q42 0 71.5 -20t37.5 -55l-22 -15q-5 29 -30.5 47t-61.5 18q-58 0 -103 -48t-65 -137q21 36 61.5 57t83.5 21q54 0 87.5 -31.5t33.5 -78.5z M229 439q28 0 54.5 10t47 27t33 39t12.5 47q0 19 -7.5 36t-21 29.5t-32.5 20t-41 7.5q-28 0 -54.5 -10t-47 -27t-33 -39.5t-12.5 -47.5q0 -38 29 -65t73 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 321,
    d: "M369 784h-242l5 26h285l-300 -388h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 372,
    d: "M381 544q0 -28 -15 -51.5t-39 -40t-55 -25.5t-63 -9q-57 0 -89.5 28.5t-32.5 67.5q0 23 10.5 42t27 33.5t37.5 25t41 16.5q-26 9 -43.5 27t-17.5 44q0 25 14 45.5t36 34t49 21t53 7.5q21 0 41 -5.5t35.5 -15.5t25 -25.5t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-30.5 -21.5 t-36 -15q32 -11 52 -33t20 -54zM354 542q0 18 -9 32t-23 24t-32 15t-37 5q-24 0 -48.5 -7t-44.5 -20.5t-32.5 -32t-12.5 -40.5q0 -18 9 -31.5t23.5 -23t32.5 -14.5t37 -5q23 0 47.5 7t44.5 19.5t32.5 30.5t12.5 41zM169 703q0 -15 8 -26.5t20.5 -19.5t28 -12t31.5 -4 q19 0 40.5 5.5t39.5 16t29.5 26t11.5 34.5q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-38 -16.5t-27.5 -25.5t-10.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 383,
    d: "M113 656q0 31 15 59t39.5 49t57 33.5t67.5 12.5q56 0 89.5 -33t33.5 -91q0 -56 -15 -105.5t-43 -86.5t-66.5 -58.5t-85.5 -21.5q-42 0 -71.5 20t-36.5 55l21 15q5 -29 30.5 -47t62.5 -18q57 0 102.5 48t64.5 136q-21 -35 -61.5 -56.5t-83.5 -21.5q-54 0 -87 32t-33 79z M286 785q-28 0 -54.5 -10t-46.5 -27t-32.5 -39t-12.5 -47q0 -39 28 -66t73 -27q28 0 54.5 10t47 27t33 39.5t12.5 47.5q0 38 -28.5 65t-73.5 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 427,
    d: "M132 -85q-36 0 -62 14.5t-42.5 37t-24 51t-7.5 57.5q0 40 17 81t47 75t70 55.5t85 21.5q36 0 61.5 -14.5t42 -38t24 -52t7.5 -56.5q0 -40 -17 -81.5t-46.5 -75t-69 -54.5t-85.5 -21zM24 78q0 -25 7 -49.5t21 -44t35.5 -31.5t50.5 -12q41 0 75 20t58 50.5t37.5 66 t13.5 65.5q0 25 -7 50t-21 44.5t-35.5 31.5t-49.5 12q-41 0 -75 -20t-58.5 -50.5t-38 -66t-13.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 250,
    d: "M156 -54l-6 -26h-183l5 26h81l71 334q-6 -6 -18.5 -14.5t-27.5 -15.5t-30.5 -12t-27.5 -5l6 26q15 0 33 8t34 18t26.5 19t11.5 10h27l-78 -368h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 361,
    d: "M-41 -80q16 75 55 114.5t100 61.5q26 9 53.5 18t50.5 21.5t37.5 31.5t14.5 49q0 29 -21 50t-66 21q-26 0 -47 -6t-38 -15t-29.5 -19.5t-20.5 -18.5l-15 18q2 3 14 13.5t32.5 22.5t48.5 21.5t63 9.5q57 0 83 -26.5t26 -64.5q0 -34 -15.5 -57.5t-39.5 -39.5t-53.5 -26.5 t-56.5 -19.5q-38 -13 -62.5 -30t-39 -35t-21.5 -35.5t-10 -32.5h242l-6 -26h-279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 366,
    d: "M98 -85q-21 0 -43 4.5t-39.5 15t-29 29t-11.5 45.5l22 13q0 -35 28 -58t79 -23q27 0 52 7t43.5 19.5t29.5 29t11 36.5q0 34 -33.5 53.5t-91.5 19.5h-21l5 24h21q69 0 108 22t39 64q0 32 -27 52t-69 20q-40 0 -73 -16.5t-51 -42.5l-15 19q21 29 60.5 47t83.5 18 q54 0 87 -26.5t33 -65.5q0 -80 -106 -103q36 -7 56.5 -29.5t20.5 -53.5q0 -27 -14 -49t-37.5 -37.5t-54 -24.5t-63.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 357,
    d: "M165 -80l23 108h-220l5 24l282 256h19l-54 -254h53l-5 -26h-53l-24 -108h-26zM7 54h187l45 211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 354,
    d: "M148 165q51 0 83.5 -28.5t32.5 -73.5q0 -33 -15 -60t-39.5 -46.5t-56 -30.5t-64.5 -11q-45 0 -76.5 21t-42.5 55l23 12q11 -29 38 -46t65 -17q28 0 53 9t44.5 25t31 37.5t11.5 46.5q0 20 -8 35.5t-21.5 26t-31 16t-36.5 5.5q-31 0 -61 -13t-52 -36h-26q4 9 12 27.5 t18 41.5t20.5 47.5t19.5 45t15.5 35.5t7.5 19h204l-6 -27h-182l-68 -152q23 18 50.5 27t56.5 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 383,
    d: "M296 69q0 -32 -15 -60t-40 -49t-57.5 -33t-67.5 -12q-55 0 -88.5 33t-33.5 91q0 56 15.5 105.5t43.5 86.5t66.5 58.5t84.5 21.5q42 0 71.5 -20t36.5 -55l-21 -15q-5 29 -30.5 47t-61.5 18q-58 0 -103 -48t-65 -137q21 35 61.5 56.5t83.5 21.5q54 0 87 -31.5t33 -78.5z M123 -60q28 0 54.5 10t47 27t33 39t12.5 47q0 19 -7.5 36t-21 29.5t-32.5 20t-41 7.5q-28 0 -54.5 -10t-47 -27t-33 -39.5t-12.5 -47.5q0 -38 29 -65t73 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 321,
    d: "M262 281h-242l5 27h285l-300 -388h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 371,
    d: "M274 41q0 -28 -14.5 -51t-38.5 -39.5t-55 -25.5t-64 -9q-58 0 -90 28.5t-32 67.5q0 22 10.5 41t27 34t37 25t40.5 16q-25 9 -42.5 27.5t-17.5 44.5q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -16t25 -26t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5 t-37 -15q32 -10 52.5 -32.5t20.5 -54.5zM247 40q0 18 -9 32t-23.5 23.5t-32.5 15t-37 5.5q-23 0 -47.5 -7.5t-44.5 -20.5t-32.5 -31.5t-12.5 -40.5q0 -18 9 -31.5t23.5 -23.5t32.5 -15t37 -5q23 0 47.5 7t44.5 20t32.5 31t12.5 41zM63 201q0 -15 7.5 -26.5t20 -19.5 t28.5 -12t32 -4q19 0 40.5 5.5t39 16t29 25.5t11.5 35q0 29 -27 45.5t-63 16.5q-22 0 -43 -6t-37.5 -16.5t-27 -26t-10.5 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 384,
    d: "M7 157q0 31 15 59t40 49t57.5 33.5t67.5 12.5q56 0 89.5 -33.5t33.5 -91.5q0 -56 -15 -105t-43 -86t-66.5 -58.5t-85.5 -21.5q-43 0 -72 20t-37 55l22 15q5 -29 30.5 -47t61.5 -18q57 0 102.5 48t65.5 136q-22 -35 -62 -56.5t-84 -21.5q-27 0 -49 8.5t-38 23.5 t-24.5 35.5t-8.5 43.5zM181 286q-28 0 -54.5 -10t-47 -27t-33 -39.5t-12.5 -46.5q0 -39 28.5 -66t73.5 -27q28 0 54.5 10t47 27t33 39.5t12.5 47.5q0 38 -28.5 65t-73.5 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 519,
    d: "M158 0q-60 22 -94.5 78.5t-34.5 131.5q0 55 19 105.5t51.5 92t76 71t93.5 41.5l27 125h24l-26 -120q19 3 39 3q7 0 13 -0.5t12 -1.5l26 119h25l-27 -123q45 -11 75.5 -39.5t41.5 -72.5l-37 -12q-13 46 -50 72t-88 26q-50 0 -96.5 -22.5t-83.5 -61t-59 -89.5t-22 -108 q0 -40 12 -75t33 -61.5t50.5 -41.5t65.5 -15q27 0 56 8.5t54.5 22.5t45.5 32.5t30 39.5l32 -10q-24 -44 -70.5 -76t-100.5 -43l-25 -116h-24l23 112q-6 -2 -12 -2h-12q-10 0 -20 1t-20 3l-24 -114h-24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 594,
    d: "M54 0l31 146h-89l6 30h89l114 534h436l-6 -32h-403l-63 -300h342l-7 -31h-342l-37 -171h150l-6 -30h-150l-31 -146h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 447,
    d: "M62 374h95q-11 37 -22 71t-11 73q0 40 17 75.5t45 62.5t64 43t73 16q49 0 85.5 -28.5t52.5 -76.5l-28 -21q-14 45 -45 70t-73 25q-29 0 -57.5 -13t-50.5 -35t-35.5 -51.5t-13.5 -62.5q0 -39 11 -74t22 -74h171l-6 -27h-158q3 -15 4.5 -31t2.5 -33h152l-5 -26h-148 q-2 -24 -9.5 -47t-25.5 -49.5t-48 -58.5t-76 -74q35 8 70 8q21 0 38 -3t32 -6.5t30.5 -6.5t33.5 -3q20 0 42.5 4.5t52.5 15.5l4 -29q-58 -23 -107 -23q-21 0 -38.5 3.5t-34 7t-34 7t-38.5 3.5t-47.5 -3.5t-49.5 -9.5l-6 26q52 46 86 79.5t54 60t28 49.5t10 49h-102l5 26h98 q-1 34 -9 64h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 788,
    d: "M765 376h-79l-14 -68h79l-5 -26h-80l-59 -282h-34l-153 282h-273l-60 -282h-34l60 282h-79l5 26h79l15 68h-79l5 27h79l66 307h26l166 -307h262l65 306h34l-65 -306h79zM172 403h182l-130 241zM584 55l48 227h-171zM152 308h254l-37 68h-202zM447 308h190l15 68h-242z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1033,
    d: "M54 367h136l-13 69h-108l5 27h97l-48 247h37l47 -247h299l-47 241h35l49 -262l161 262h35l-150 -241h300l153 247h37l-154 -247h97l-6 -27h-107l-43 -69h135l-5 -27h-147l-211 -340h-34l-73 378l-235 -378h-34l-66 340h-148zM629 41l184 299h-242zM288 41l185 299h-243z M565 367h265l42 69h-300l-15 -25zM512 436h-300l13 -69h264l28 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 772,
    d: "M160 405q18 60 54 116t86 98.5t112 68.5t133 26q45 0 81 -11.5t63 -32t45 -49t26 -62.5l-33 -14q-11 38 -30.5 64t-45 42t-55.5 23t-61 7q-62 0 -116.5 -23t-98.5 -61.5t-76 -88t-49 -103.5h361l-18 -26h-350q-10 -37 -11 -68h322l-18 -27h-304q1 -53 17.5 -99.5 t45 -81.5t68.5 -55.5t90 -20.5q32 0 67 8.5t70 26t68 44.5t60 65l27 -12q-26 -40 -61.5 -71t-76.5 -52t-83.5 -31.5t-81.5 -10.5q-57 0 -102 24t-76 64.5t-48 93t-18 108.5h-114l18 27h96q1 17 3.5 34t6.5 34h-69l17 26h59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 411,
    d: "M430 587h-89q8 -29 8 -56q0 -45 -17.5 -88.5t-47 -78.5t-69 -58.5t-83.5 -27.5l111 -278h-40l-122 306h35q41 0 77 20t62.5 51.5t42 70.5t15.5 78q0 34 -10 61h-202l5 27h185q-16 29 -42 46.5t-60 17.5h-69l7 32h329l-6 -27h-170q17 -13 30.5 -31t22.5 -38h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 316,
    d: "M164 -5q-42 0 -64.5 23.5t-22.5 71.5v520q0 28 6.5 51.5t18.5 41t28.5 27.5t35.5 10q38 0 62 -36t24 -94q0 -39 -12 -82.5t-31.5 -86.5t-45.5 -82t-54 -68v-203q0 -29 18 -46t49 -17q13 0 28.5 4.5t29.5 10.5l9 -28q-18 -8 -38.5 -12.5t-40.5 -4.5zM221 604 q0 51 -14 78.5t-40 27.5t-42 -27.5t-16 -72.5v-279q22 27 42.5 62.5t36 73t24.5 73.5t9 64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1064,
    d: "M202 644l-137 -644h-35l151 710h26l355 -655l138 654h35l-151 -709h-33zM882 354q-31 0 -56 12t-42 32t-26.5 46.5t-9.5 56.5q0 42 17.5 80.5t46.5 68t67 47t79 17.5q31 0 56 -11.5t43 -31.5t27.5 -47t9.5 -57q0 -41 -17.5 -79.5t-47 -68t-67.5 -47.5t-80 -18zM780 504 q0 -26 8 -48t22 -38.5t34 -26t44 -9.5q32 0 63 15t55.5 39.5t39.5 57.5t15 69q0 26 -8 48.5t-22 39t-34 26t-44 9.5q-32 0 -63 -14.5t-55.5 -39.5t-39.5 -58t-15 -70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 647,
    d: "M627 710h35l-60 -280h-27l50 233l-130 -191h-23l-49 191l-49 -233h-28l60 280h34l51 -203zM305 657q-9 17 -24 24t-37 7q-43 0 -62 -16.5t-19 -42.5q0 -20 21 -29t50 -17q29 -9 51 -23t22 -43q0 -45 -33 -67.5t-84 -22.5q-64 0 -98 44l18 22q28 -40 86 -40q37 0 59 14 t22 43q0 20 -17.5 29.5t-43.5 17.5q-16 5 -30.5 10t-26 12.5t-18.5 17.5t-7 25q0 44 32.5 68.5t83.5 24.5q53 0 77 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 644,
    d: "M345 684h-90l-54 -254h-28l54 254h-90l6 28h208zM395 710h34l50 -203l137 203h35l-60 -280h-27l49 233l-129 -191h-23l-49 191l-49 -233h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 816,
    d: "M61 33h210q-48 22 -86 57t-64 78.5t-40 93.5t-14 103q0 69 25 132.5t69 111.5t104.5 77t131.5 29t131.5 -29t104.5 -77t69 -111.5t25 -132.5q0 -53 -14 -103t-40.5 -93.5t-64.5 -78.5t-86 -57h211v-33h-289v33q60 13 106 47t77.5 80t47.5 99.5t16 105.5q0 59 -20.5 115.5 t-58.5 101t-92.5 72t-122.5 27.5q-69 0 -123.5 -27.5t-92.5 -72t-58.5 -101t-20.5 -115.5q0 -52 16 -105.5t47.5 -99.5t78 -80t106.5 -47v-33h-289v33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 616,
    d: "M305 13q69 0 119.5 22.5t79.5 55.5l16 -18q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-448v-150q32 -42 79.5 -67t104.5 -25zM305 508q-57 0 -104.5 -25.5 t-79.5 -68.5v-135h370v134q-33 44 -82.5 69.5t-103.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 772,
    d: "M19 16l676 696l18 -17l-676 -697zM251 364l-6 -27h-178l6 27h78l71 334q-6 -6 -18.5 -14.5t-27 -16t-29.5 -12.5t-27 -5l6 27q15 0 32.5 8t33 18t26 18.5t10.5 9.5h28l-79 -367h74zM524 -5q-21 0 -43 5.5t-39.5 17t-29 29.5t-11.5 42l22 13q0 -32 28 -56.5t79 -24.5 q27 0 52 7t43.5 19.5t29.5 29t11 36.5q0 34 -33 53.5t-92 19.5h-21l5 24h21q69 0 108 22t39 64q0 32 -27 52t-69 20q-40 0 -73 -16.5t-51 -42.5l-15 19q21 29 60.5 47t83.5 18q54 0 87 -26.5t33 -65.5q0 -80 -106 -103q36 -7 56.5 -29.5t20.5 -53.5q0 -27 -14 -49 t-37.5 -37.5t-54 -24.5t-63.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 788,
    d: "M53 338q16 76 54.5 115t99.5 61q25 9 52.5 18t50 22t37 32t14.5 49q0 28 -20.5 49t-65.5 21q-25 0 -46 -6t-38 -15t-29.5 -19.5t-20.5 -18.5l-15 18q2 3 14 13.5t32.5 22.5t48.5 21.5t62 9.5q57 0 82.5 -26.5t25.5 -64.5q0 -34 -15.5 -57.5t-39.5 -39.5t-53 -27t-56 -20 q-38 -13 -62 -29.5t-38.5 -34.5t-21.5 -35.5t-10 -32.5h239l-5 -26h-276zM71 16l676 696l18 -17l-676 -697zM538 -5q-21 0 -43 5.5t-39.5 17t-29 29.5t-11.5 42l22 13q0 -32 28 -56.5t79 -24.5q27 0 52 7t43.5 19.5t29.5 29t11 36.5q0 34 -33 53.5t-92 19.5h-21l5 24h21 q69 0 108 22t39 64q0 32 -27 52t-69 20q-40 0 -73 -16.5t-51 -42.5l-15 19q21 29 60.5 47t83.5 18q54 0 87 -26.5t33 -65.5q0 -80 -106 -103q36 -7 56.5 -29.5t20.5 -53.5q0 -27 -14 -49t-37.5 -37.5t-54 -24.5t-63.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 772,
    d: "M29 16l676 696l18 -17l-676 -697zM249 364l-6 -27h-178l6 27h78l71 334q-6 -6 -18.5 -14.5t-27 -16t-29.5 -12.5t-27 -5l6 27q15 0 32.5 8t33 18t26 18.5t10.5 9.5h28l-79 -367h74zM523 -4q-57 0 -89.5 28.5t-32.5 67.5q0 22 10.5 41t27 34t37 25t40.5 16 q-25 9 -42.5 27.5t-17.5 44.5q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -16t25 -26t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15q32 -10 52.5 -32.5t20.5 -54.5q0 -28 -14.5 -51t-38.5 -39.5t-55 -25.5t-64 -9zM531 21q23 0 47.5 7t44.5 20t32.5 31 t12.5 41q0 18 -9 32t-23.5 23.5t-32.5 15t-37 5.5q-23 0 -47.5 -7.5t-44.5 -20.5t-32.5 -31.5t-12.5 -40.5q0 -18 9 -31.5t23.5 -23.5t32.5 -15t37 -5zM572 219q19 0 40.5 5.5t39 16t29 25.5t11.5 35q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-37.5 -16.5 t-27 -26t-10.5 -33.5q0 -15 7.5 -26.5t20 -19.5t28.5 -12t32 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 777,
    d: "M192 333q-21 0 -43 5.5t-40 17t-29 29.5t-11 42l22 13q0 -32 27.5 -56t79.5 -24q27 0 51.5 7t43.5 19t30 29t11 37q0 33 -33.5 52.5t-91.5 19.5h-21l5 24h21q69 0 107.5 22.5t38.5 64.5q0 32 -26.5 51.5t-68.5 19.5q-40 0 -73 -16.5t-51 -42.5l-15 19q21 30 60.5 47.5 t83.5 17.5q54 0 86.5 -26t32.5 -66q0 -39 -26.5 -65t-79.5 -37q37 -7 57.5 -30t20.5 -53q0 -27 -14 -49.5t-37.5 -38t-54 -24.5t-63.5 -9zM51 16l676 696l18 -17l-676 -697zM526 -4q-57 0 -89.5 28.5t-32.5 67.5q0 22 10.5 41t27 34t37 25t40.5 16q-25 9 -42.5 27.5 t-17.5 44.5q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -16t25 -26t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15q32 -10 52.5 -32.5t20.5 -54.5q0 -28 -14.5 -51t-38.5 -39.5t-55 -25.5t-64 -9zM534 21q23 0 47.5 7t44.5 20t32.5 31t12.5 41 q0 18 -9 32t-23.5 23.5t-32.5 15t-37 5.5q-23 0 -47.5 -7.5t-44.5 -20.5t-32.5 -31.5t-12.5 -40.5q0 -18 9 -31.5t23.5 -23.5t32.5 -15t37 -5zM575 219q19 0 40.5 5.5t39 16t29 25.5t11.5 35q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-37.5 -16.5t-27 -26 t-10.5 -33.5q0 -15 7.5 -26.5t20 -19.5t28.5 -12t32 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 777,
    d: "M240 587q52 0 84.5 -28t32.5 -73q0 -33 -15 -60t-39.5 -47t-56 -31t-64.5 -11q-45 0 -76.5 21t-42.5 56l23 11q11 -29 37.5 -46t65.5 -17q28 0 53 9t44.5 25t31 37.5t11.5 47.5q0 20 -8 35t-21.5 25.5t-31 16t-36.5 5.5q-31 0 -61.5 -13t-51.5 -35h-26q6 14 20.5 47 t30 68.5t28 64.5t14.5 35h204l-6 -26h-183l-67 -153q23 18 50 27t56 9zM44 16l676 696l18 -17l-676 -697zM527 -4q-57 0 -89.5 28.5t-32.5 67.5q0 22 10.5 41t27 34t37 25t40.5 16q-25 9 -42.5 27.5t-17.5 44.5q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -16 t25 -26t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15q32 -10 52.5 -32.5t20.5 -54.5q0 -28 -14.5 -51t-38.5 -39.5t-55 -25.5t-64 -9zM535 21q23 0 47.5 7t44.5 20t32.5 31t12.5 41q0 18 -9 32t-23.5 23.5t-32.5 15t-37 5.5q-23 0 -47.5 -7.5t-44.5 -20.5 t-32.5 -31.5t-12.5 -40.5q0 -18 9 -31.5t23.5 -23.5t32.5 -15t37 -5zM576 219q19 0 40.5 5.5t39 16t29 25.5t11.5 35q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-37.5 -16.5t-27 -26t-10.5 -33.5q0 -15 7.5 -26.5t20 -19.5t28.5 -12t32 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 770,
    d: "M-11 16l676 696l18 -17l-676 -697zM522 -4q-57 0 -89.5 28.5t-32.5 67.5q0 22 10.5 41t27 34t37 25t40.5 16q-25 9 -42.5 27.5t-17.5 44.5q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -16t25 -26t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15 q32 -10 52.5 -32.5t20.5 -54.5q0 -28 -14.5 -51t-38.5 -39.5t-55 -25.5t-64 -9zM530 21q23 0 47.5 7t44.5 20t32.5 31t12.5 41q0 18 -9 32t-23.5 23.5t-32.5 15t-37 5.5q-23 0 -47.5 -7.5t-44.5 -20.5t-32.5 -31.5t-12.5 -40.5q0 -18 9 -31.5t23.5 -23.5t32.5 -15t37 -5z M571 219q19 0 40.5 5.5t39 16t29 25.5t11.5 35q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-37.5 -16.5t-27 -26t-10.5 -33.5q0 -15 7.5 -26.5t20 -19.5t28.5 -12t32 -4zM370 704h-243l6 26h285l-300 -388h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 568,
    d: "M254 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 48 19.5 91t53.5 76t79 52.5t95 19.5q36 0 68 -10.5t58 -31t44.5 -50t26.5 -67.5q3 12 4.5 29.5t3 37t2 38.5t0.5 35q0 75 -13.5 126t-38.5 82.5t-59.5 45.5t-77.5 14q-55 0 -101 -19t-70 -48l-21 21q33 40 85 59 t109 19q109 0 164.5 -74t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM253 22q51 0 90 20.5t65.5 51.5t40.5 68.5t14 70.5q0 34 -14 65t-38.5 54.5t-57.5 37.5t-72 14q-42 0 -80.5 -17t-68 -45.5t-47 -66t-17.5 -79.5q0 -36 13.5 -67.5t38.5 -55.5 t58.5 -37.5t74.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 644,
    d: "M590 30v-30h-599v30l286 680h29zM553 32l-262 634l-262 -634h524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 689,
    d: "M534 678h-339v-768h-33v768h-88v32h573v-32h-80v-768h-33v768z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 573,
    d: "M494 679h-370v-4l223 -306l-228 -329v-4h390v-36h-433v31l231 337l-227 313v29h414v-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 549,
    d: "M68 263v30h403v-30h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 550,
    d: "M-63 17l680 695l19 -19l-679 -695z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 164,
    d: "M55 249l19 91h31l-19 -91h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 385,
    d: "M23 365h109l87 -328l128 753h34l-140 -790h-44l-94 336h-80v29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 699,
    d: "M211 517q30 0 52.5 -10t39.5 -27t30.5 -39.5t25.5 -47.5q11 25 24.5 47.5t31 39.5t40 27t52.5 10q34 0 62 -13t48 -35.5t30.5 -53t10.5 -64.5t-11.5 -64t-32 -52.5t-48.5 -35.5t-60 -13q-29 0 -51 10t-39 27t-30.5 39.5t-24.5 46.5q-11 -24 -24 -46.5t-31 -39.5t-41 -27 t-54 -10q-32 0 -59.5 13t-48 35.5t-32.5 53t-12 64.5t11.5 64t32 52.5t48 35.5t60.5 13zM211 216q26 0 46 11t36 29t28.5 42.5t24.5 51.5q-12 28 -24.5 52.5t-28.5 43.5t-36 30t-46 11q-22 0 -43.5 -8.5t-39 -25t-28.5 -42t-11 -59.5q0 -33 11 -58.5t28.5 -43t39 -26 t43.5 -8.5zM507 216q22 0 43.5 8.5t38.5 26t27.5 43t10.5 58.5q0 34 -10.5 59.5t-27.5 42t-38.5 24.5t-43.5 8q-27 0 -47 -11.5t-36 -30.5t-28 -44.5t-23 -53.5q11 -26 24 -49.5t29 -41.5t35.5 -28.5t45.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 271,
    d: "M106 680q-2 26 -2 33v11q0 42 22 69t60 27q18 0 41.5 -6t41.5 -15l-10 -26q-14 7 -34.5 12.5t-31.5 5.5q-26 0 -41.5 -19.5t-15.5 -55.5v-10.5t2 -30.5l38 -701q2 -26 2 -33v-9q0 -48 -22 -73.5t-60 -25.5q-18 0 -40.5 6t-40.5 15l9 26q16 -7 34 -12.5t31 -5.5 q26 0 42 19.5t16 58.5v9t-2 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 443,
    d: "M360 305q-12 -9 -28 -15.5t-38 -6.5q-26 0 -47.5 6.5t-40.5 14.5t-36.5 14.5t-35.5 6.5q-15 0 -26.5 -5t-19.5 -13l-18 22q10 11 26 18t37 7q23 0 43 -6.5t39 -14.5t38 -14.5t41 -6.5q16 0 28 3t21 11zM360 222q-12 -9 -28 -15t-38 -6q-26 0 -47.5 6.5t-40.5 14.5 t-36.5 14.5t-35.5 6.5q-15 0 -26.5 -5t-19.5 -13l-18 22q10 11 26 18t37 7q23 0 43 -6.5t39 -14t38 -14t41 -6.5q16 0 28 2.5t21 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 460,
    d: "M76 332h164l65 106l28 -5l-62 -101h101v-29h-119l-33 -54h152v-29h-170l-65 -107l-27 5l62 102h-96v29h113l33 54h-146v29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 458,
    d: "M61 78v31h307v-31h-307zM61 370l298 152v-35l-249 -128l249 -129v-36l-298 152v24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 472,
    d: "M72 109h307v-31h-307v31zM81 230l249 129l-249 128l-8 35l306 -152v-24l-298 -152v36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 477,
    d: "M271 730l186 -364l-186 -366h-38l-186 366l186 364h38zM419 354l-171 346l-161 -325l170 -342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 125,
    d: "M15 -176l25 62h-12l14 64h36l-14 -64l-29 -62h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 743,
    d: "M169 -10q-62 0 -105.5 23.5t-69.5 56.5l23 23q65 -74 159 -74q30 0 62 7.5t58.5 23.5t44 41.5t17.5 60.5q0 28 -11.5 44.5t-31 26t-46 14t-56.5 8.5q-30 3 -57 8t-47.5 16.5t-32.5 32t-12 56.5q0 46 20 78.5t51 52.5t69 29.5t74 9.5q70 0 109 -30q-5 23 -9 43t-4 45 q0 28 8 57t28 53t54 39.5t86 15.5q58 0 79.5 -21t21.5 -66q0 -28 -6.5 -63t-15.5 -81h116l-6 -30h-117l-86 -404q-1 -5 -1 -12q0 -24 16 -35.5t39 -11.5q14 0 27.5 3.5t25 7.5t19 8t10.5 6l6 -28q-3 -1 -12.5 -5.5t-23 -10t-30.5 -9.5t-35 -4q-35 0 -56.5 17.5t-21.5 46.5 q0 14 3 26l86 405h-70l7 30h70q10 47 15.5 81t5.5 57q0 40 -17.5 54t-57.5 14q-44 0 -72 -12.5t-44 -33t-22 -46.5t-6 -52q0 -47 10.5 -79.5t15.5 -48.5l-26 -17q-17 37 -52.5 49.5t-71.5 12.5q-31 0 -62.5 -7t-56.5 -23t-40.5 -40.5t-15.5 -60.5q0 -30 11 -47.5t29.5 -27 t43 -14t50.5 -7.5q28 -3 56.5 -7.5t51.5 -16.5t38 -33.5t15 -57.5q0 -44 -21 -75.5t-54 -52t-72.5 -30t-76.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 559,
    d: "M321 542h27l123 -542h-34l-42 183h-274l-120 -183h-35zM391 212l-66 288l-189 -288h255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 548,
    d: "M141 542h256q25 0 43.5 -9.5t31.5 -25t19.5 -36t6.5 -41.5q0 -50 -31 -91.5t-79 -60.5q37 -12 57.5 -43t20.5 -70q0 -34 -15.5 -64t-40.5 -52.5t-57.5 -35.5t-66.5 -13h-260zM292 29q27 0 52 11.5t45 30.5t32 43.5t12 49.5q0 19 -6 36.5t-17.5 30.5t-27.5 21t-36 8h-233 l-48 -231h227zM331 288q27 0 51 11.5t42 30t29 42.5t11 50q0 37 -21.5 63.5t-59.5 26.5h-216l-48 -224h212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 571,
    d: "M246 -5q-49 0 -87.5 19.5t-65 52t-40.5 74.5t-14 87q0 55 24.5 111t68 102t103.5 75t132 29q74 0 119.5 -33.5t59.5 -84.5l-30 -15q-9 29 -25.5 48.5t-38 31.5t-46 17.5t-49.5 5.5q-63 0 -115.5 -26t-90.5 -67.5t-59 -92.5t-21 -100q0 -41 13 -78t37 -64.5t58 -44 t76 -16.5q26 0 55 6t57 19.5t54 33.5t47 49l25 -13q-21 -30 -50 -53.5t-62.5 -39.5t-68.5 -24.5t-66 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 593,
    d: "M141 542h184q55 0 95.5 -16t67 -44.5t39.5 -67t13 -83.5q0 -72 -25 -132.5t-69 -104.5t-104.5 -69t-131.5 -25h-184zM216 30q69 0 122.5 24t91 65t57 94.5t19.5 112.5q0 41 -12 75t-35.5 59t-58.5 38.5t-82 13.5h-151l-102 -482h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 508,
    d: "M141 542h363l-6 -30h-331l-47 -221h290l-7 -29h-289l-49 -232h337l-6 -30h-370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 502,
    d: "M141 542h362l-7 -30h-329l-47 -221h280l-6 -30h-281l-55 -261h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 704,
    d: "M298 -5q-59 0 -104.5 24t-77.5 64.5t-48.5 94t-16.5 111.5q0 81 33.5 157.5t89.5 136t128.5 96t149.5 36.5q84 0 140.5 -43.5t82.5 -112.5l-30 -23q-11 31 -30 58t-44.5 46.5t-57.5 30.5t-70 11q-72 0 -137 -35t-114 -91t-78 -125.5t-29 -139.5q0 -52 15 -99.5t43 -84 t69 -58t93 -21.5q56 0 108 23t96 61t77.5 87.5t51.5 102.5h-222l7 33h260q-1 -5 -3.5 -13t-4.5 -14q-20 -62 -58 -118.5t-88 -100t-109 -69t-122 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 592,
    d: "M457 86q-100 -90 -210 -90q-50 0 -88.5 19.5t-65.5 51.5t-41 73.5t-14 85.5q0 60 26 117t70 102t102 72.5t122 27.5q42 0 73.5 -8.5t54 -24.5t37.5 -37.5t23 -46.5l-31 -16q-17 55 -60.5 79.5t-103.5 24.5q-59 0 -110 -26t-88.5 -67t-59.5 -92t-22 -102q0 -41 13 -78 t37 -64.5t58 -43.5t76 -16q52 0 104 23t106 73l24 111h-127l5 28h158l-56 -262h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 608,
    d: "M141 542h33l-54 -249h364l53 249h32l-115 -542h-32l55 262h-364l-55 -262h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 212,
    d: "M141 541h32l-115 -541h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 406,
    d: "M85 -8q-72 0 -114 33l17 26q17 -13 43.5 -21t59.5 -8q47 0 78.5 16.5t53 48t35.5 76.5t26 103l58 275h33l-59 -275q-13 -62 -29.5 -112.5t-42 -86.5t-64 -55.5t-95.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 522,
    d: "M141 541h32l-71 -334l406 335h40l-285 -237l181 -305h-38l-169 284l-143 -116l-36 -168h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 472,
    d: "M141 542h33l-109 -512h334l-6 -30h-367z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 195,
    d: "M44 651l76 79h44l-99 -92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 722,
    d: "M141 542h31l157 -396l324 396h31l-115 -542h-32l101 480l-308 -376h-21l-149 376l-102 -480h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 639,
    d: "M141 542h25l299 -488l103 487h32l-114 -541h-32l-294 481l-102 -481h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 623,
    d: "M247 -4q-50 0 -89 19t-65.5 50.5t-40.5 72.5t-14 85q0 61 27.5 119t72.5 103t104 72.5t122 27.5q50 0 88.5 -19t65 -51t40 -73t13.5 -85q0 -61 -27 -119t-72 -103t-103.5 -72t-121.5 -27zM254 27q58 0 110 25.5t91 67t61.5 92.5t22.5 102q0 40 -12.5 76.5t-36.5 64 t-57.5 44t-75.5 16.5q-58 0 -110 -25.5t-91 -66.5t-62 -92.5t-23 -103.5q0 -40 12.5 -76t36 -63.5t57.5 -44t77 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 517,
    d: "M141 542h229q30 0 54 -12t40.5 -31.5t25.5 -44.5t9 -52q0 -36 -15.5 -70.5t-42 -62.5t-62 -45t-75.5 -17h-202l-44 -207h-32zM309 237q33 0 61.5 14.5t49.5 37.5t33 51.5t12 57.5q0 23 -7.5 43.5t-21 36.5t-32.5 25t-42 9h-195l-58 -275h200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 622,
    d: "M419 52q-38 -26 -82 -41t-90 -15q-50 0 -89 19t-65.5 50.5t-40.5 72.5t-14 85q0 61 27.5 119t72.5 103t104 72.5t122 27.5q50 0 88.5 -19t65 -51t40 -73t13.5 -85q0 -71 -36 -136t-93 -112l44 -69h-35zM254 27q41 0 79 13t71 36l-48 78h34l37 -60q51 42 81 101t30 119 q0 40 -12.5 76.5t-36 64.5t-57 44.5t-75.5 16.5q-58 0 -110 -26t-91.5 -67t-62.5 -92.5t-23 -103.5q0 -40 12.5 -76t36.5 -63.5t58 -44t77 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 539,
    d: "M141 542h231q30 0 54 -12t40.5 -31.5t25.5 -44.5t9 -52q0 -34 -13.5 -66t-37 -58.5t-55 -44t-67.5 -21.5l95 -212h-38l-93 207h-190l-44 -207h-32zM311 237q32 0 60.5 14.5t50 37.5t34 51.5t12.5 57.5q0 22 -7.5 43t-21 36.5t-32.5 25t-43 9.5h-197l-58 -275h202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 505,
    d: "M199 -4q-66 0 -115.5 20t-86.5 61l24 25q29 -38 75 -58t110 -20q42 0 76.5 8t59.5 24.5t39 40.5t14 57q0 44 -38.5 65.5t-116.5 37.5q-38 8 -67.5 17t-49.5 22t-30.5 31.5t-10.5 44.5q0 41 17 73t48 54.5t73 34t92 11.5q54 0 92.5 -15t64.5 -48l-22 -26 q-23 32 -56.5 46.5t-83.5 14.5q-51 0 -87 -10.5t-59.5 -29t-34.5 -43.5t-11 -54q0 -21 9 -35.5t27 -25t45 -18.5t64 -16q39 -8 70 -17.5t53.5 -23t34.5 -33.5t12 -49q0 -41 -17 -72t-47.5 -52t-73 -31.5t-93.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 499,
    d: "M277 512h-208l7 30h447l-7 -30h-206l-109 -512h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 622,
    d: "M247 -4q-51 0 -86 14.5t-56.5 39.5t-31 58.5t-9.5 71.5q0 22 3 44.5t8 45.5l57 272h33l-58 -272q-9 -42 -9 -85q0 -33 8 -62t26 -50t47.5 -33.5t73.5 -12.5q58 0 101 21t73 55.5t48.5 78t28.5 88.5l58 272h31l-57 -272q-12 -54 -34.5 -104t-58 -87.5t-84 -60 t-112.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 557,
    d: "M73 542h34l115 -498l324 498h35l-354 -542h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 983,
    d: "M105 710h37l59 -663l349 663h38l75 -663l340 663h39l-368 -710h-37l-79 654l-350 -654h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 844,
    d: "M73 542h35l116 -502l177 271l-50 227h32l43 -199l128 199h33l-148 -227l64 -271l329 502h35l-355 -542h-31l-66 284l-186 -284h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 517,
    d: "M233 267l-163 275h38l149 -250l254 250h38l-279 -275l157 -267h-37l-144 243l-246 -243h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 518,
    d: "M219 207l-150 335h36l136 -305l268 305h36l-294 -336l-44 -206h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 516,
    d: "M-23 28l509 484h-402l7 30h441l-6 -28l-508 -484h402l-6 -30h-443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    d: "M213 -10q-44 0 -78.5 18t-58 48t-36 69.5t-12.5 82.5q0 63 25.5 120.5t67.5 102t95.5 71t108.5 26.5q66 0 108.5 -36t60.5 -91l24 116h34l-110 -517h-34l25 115q-42 -55 -99.5 -90t-120.5 -35zM224 22q34 0 66 11.5t60.5 32t52 47.5t41.5 57l38 177q-5 31 -18 58.5 t-33.5 47.5t-47.5 31.5t-59 11.5q-53 0 -100 -26t-83 -66.5t-57 -91.5t-21 -100q0 -38 11 -72.5t31.5 -60.5t50.5 -41.5t68 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 506,
    d: "M131 -10q-30 0 -54 10t-41 28t-26.5 42t-9.5 52q0 50 23.5 84t59 55t77.5 30t80 9q58 0 97 -10t56 -18l12 56q6 24 6 47q0 57 -32 90.5t-92 33.5q-37 0 -81 -16.5t-92 -47.5l-9 25q45 28 93 48t96 20q77 0 114 -40.5t37 -105.5q0 -28 -6 -56l-70 -326h-33l18 86 q-48 -50 -107 -73t-116 -23zM142 19q25 0 52.5 5t54.5 16t51 27t43 39q10 11 15.5 21t7.5 19l21 98q-35 16 -73 23t-77 7q-32 0 -68 -7.5t-66 -24.5t-50 -45t-20 -70q0 -49 31.5 -78.5t77.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 802,
    d: "M218 -10q-45 0 -80.5 18.5t-59.5 49t-37 70.5t-13 83q0 58 24 115t64.5 102t95 72.5t114.5 27.5q47 0 78.5 -12t52.5 -34q-8 20 -16 47.5t-8 57.5q0 32 11.5 62t33 52.5t51.5 36t67 13.5q65 0 89 -24.5t24 -69.5q0 -28 -6.5 -62.5t-14.5 -74.5h116l-6 -30h-117l-86 -404 q-1 -3 -1 -10q0 -24 15.5 -36.5t37.5 -12.5q23 0 44.5 7.5t39.5 17.5l6 -28q-26 -13 -49 -21t-55 -8t-53.5 17.5t-21.5 48.5q0 5 0.5 10t1.5 10l87 409h-70l6 30h71q7 34 13.5 66t6.5 58q0 37 -18.5 59.5t-70.5 22.5q-31 0 -55 -11.5t-40 -31t-24.5 -44t-8.5 -50.5 q0 -24 5.5 -51t12.5 -52t13.5 -45t8.5 -31l-34 -12q-16 52 -54 75t-91 23q-54 0 -100.5 -26t-81 -67t-54 -90.5t-19.5 -97.5q0 -39 11.5 -74.5t32.5 -61.5t51 -41.5t67 -15.5q22 0 49.5 7t54 20.5t48.5 32.5t34 43l30 -10q-17 -31 -43 -54.5t-56.5 -39t-62.5 -23.5t-61 -8z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 582,
    d: "M216 -10q-44 0 -79 18t-59 48.5t-36.5 70.5t-12.5 83q0 60 24 117.5t64.5 102t93 71.5t109.5 27q33 0 59.5 -10t47.5 -27.5t37 -40.5t27 -48l69 328h34l-155 -730h-34l22 105q-41 -51 -98 -83t-113 -32zM227 22q27 0 61 12t65.5 32.5t56 48t32.5 57.5l38 179 q-3 30 -18 56.5t-37 46t-49.5 31t-56.5 11.5q-52 0 -98.5 -25.5t-81 -65.5t-55 -90.5t-20.5 -99.5q0 -39 11.5 -74.5t33 -61.5t51.5 -41.5t67 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 561,
    d: "M490 223q0 -52 -24 -94.5t-63 -72.5t-89 -46.5t-102 -16.5q-45 0 -79.5 13.5t-58.5 36.5t-36.5 53.5t-12.5 64.5q0 43 18 79t45.5 64t62 47.5t67.5 29.5q-40 17 -67.5 50t-27.5 81q0 47 22.5 84t58 62.5t79 38.5t85.5 13q33 0 64 -9.5t54.5 -28t38 -45.5t14.5 -61 q0 -35 -14 -64t-37 -52t-52 -40.5t-60 -28.5q50 -17 82 -59t32 -99zM456 221q0 34 -14 61t-37.5 45.5t-52.5 28t-59 9.5q-39 0 -80.5 -14.5t-75 -41t-55.5 -63t-22 -80.5q0 -34 14 -60.5t37 -45t52 -28t59 -9.5q39 0 80.5 14t75.5 40t56 62.5t22 81.5zM157 514 q0 -29 12.5 -51t32.5 -37t46 -23t52 -8q32 0 68 11t66 32.5t50 52t20 69.5q0 28 -11.5 50t-31.5 37t-46.5 23t-55.5 8q-36 0 -72.5 -11.5t-65 -33t-46.5 -52t-18 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 534,
    d: "M193 -10q-72 0 -120 39.5t-63 103.5l30 10q14 -54 57 -87.5t103 -33.5q46 0 89.5 18t77 50t53.5 75.5t20 93.5q0 34 -11 63t-31 49.5t-48 32t-61 11.5q-51 0 -101.5 -24t-89.5 -69h-35q3 8 12 29t20.5 49.5t25.5 62.5t28 69q33 80 71 178h322l-7 -33h-295l-122 -304 q39 36 85.5 55t94.5 19q39 0 71.5 -13.5t56 -37.5t36.5 -57.5t13 -73.5q0 -60 -24.5 -110.5t-64 -87t-90.5 -57t-103 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 354,
    d: "M237 587q52 0 84.5 -28t32.5 -73q0 -33 -15 -60t-39.5 -47t-56 -31t-64.5 -11q-45 0 -76.5 21t-42.5 56l23 11q11 -29 37.5 -46t65.5 -17q28 0 53 9t44.5 25t31 37.5t11.5 47.5q0 20 -8 35t-21.5 25.5t-31 16t-36.5 5.5q-31 0 -61.5 -13t-51.5 -35h-26q6 14 20.5 47 t30 68.5t28 64.5t14.5 35h204l-6 -26h-183l-67 -153q23 18 50 27t56 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 371,
    d: "M119 -4q-57 0 -89.5 28.5t-32.5 67.5q0 22 10.5 41t27 34t37 25t40.5 16q-25 9 -42.5 27.5t-17.5 44.5q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -16t25 -26t9.5 -34.5q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15q32 -10 52.5 -32.5t20.5 -54.5 q0 -28 -14.5 -51t-38.5 -39.5t-55 -25.5t-64 -9zM127 21q23 0 47.5 7t44.5 20t32.5 31t12.5 41q0 18 -9 32t-23.5 23.5t-32.5 15t-37 5.5q-23 0 -47.5 -7.5t-44.5 -20.5t-32.5 -31.5t-12.5 -40.5q0 -18 9 -31.5t23.5 -23.5t32.5 -15t37 -5zM168 219q19 0 40.5 5.5t39 16 t29 25.5t11.5 35q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-37.5 -16.5t-27 -26t-10.5 -33.5q0 -15 7.5 -26.5t20 -19.5t28.5 -12t32 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 533,
    d: "M317 0l43 205h-354l7 30l465 475h24l-101 -473h84l-7 -32h-84l-43 -205h-34zM369 237l88 416l-403 -416h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 191,
    d: "M125 517h34l-155 -730h-34zM168 718h34l-16 -72h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 206,
    d: "M177 730h34l-155 -730h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 582,
    d: "M75 429q0 58 25 110t66 91t93.5 62t108.5 23q42 0 77 -15t59.5 -42.5t38 -67.5t13.5 -90q0 -98 -25 -189.5t-70.5 -163t-109 -114.5t-140.5 -43q-69 0 -114 38.5t-54 104.5l29 16q7 -57 46.5 -92t97.5 -35q47 0 91 24.5t81 71t66.5 114t48.5 154.5q-18 -35 -45 -63.5 t-59 -49t-67.5 -32t-71.5 -11.5q-42 0 -76 15.5t-58 42.5t-37.5 63t-13.5 78zM360 684q-47 0 -92 -20t-80 -54.5t-56.5 -79.5t-21.5 -94q0 -36 12 -68t33 -56t50.5 -37.5t65.5 -13.5q46 0 91.5 20.5t80.5 54.5t57 79t22 94q0 36 -12 68t-33.5 56t-51 37.5t-65.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 354,
    d: "M4 32h127l136 642q-10 -12 -30 -26.5t-44 -28t-48.5 -22.5t-43.5 -9l7 33q25 0 54 15t54 33t42.5 33.5t18.5 17.5h35l-146 -688h120l-7 -32h-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 246,
    d: "M240 364l-6 -27h-178l6 27h78l71 334q-6 -6 -18.5 -14.5t-27 -16t-29.5 -12.5t-27 -5l6 27q15 0 32.5 8t33 18t26 18.5t10.5 9.5h28l-79 -367h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 361,
    d: "M-24 0q16 75 55 114.5t100 61.5q26 9 53.5 18t50.5 21.5t37.5 31.5t14.5 49q0 29 -21 50t-66 21q-26 0 -47 -6t-38 -15t-29.5 -19.5t-20.5 -18.5l-15 18q2 3 14 13.5t32.5 22.5t48.5 21.5t63 9.5q57 0 83 -26.5t26 -64.5q0 -35 -15.5 -58.5t-39.5 -39.5t-53 -26.5 t-57 -19.5q-38 -13 -62.5 -29.5t-39 -34.5t-21.5 -35.5t-10 -32.5h242l-6 -26h-279v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 357,
    d: "M205 108h-220l5 24l282 256h19l-54 -254h53l-5 -26h-53l-24 -108h-26zM211 134l45 211l-232 -211h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 366,
    d: "M115 -5q-21 0 -43 5.5t-39.5 17t-29 29.5t-11.5 42l22 13q0 -32 28 -56.5t79 -24.5q27 0 52 7t43.5 19.5t29.5 29t11 36.5q0 34 -33 53.5t-92 19.5h-21l5 24h21q69 0 108 22t39 64q0 32 -27 52t-69 20q-40 0 -73 -16.5t-51 -42.5l-15 19q21 29 60.5 47t83.5 18 q54 0 87 -26.5t33 -65.5q0 -80 -106 -103q36 -7 56.5 -29.5t20.5 -53.5q0 -27 -14 -49t-37.5 -37.5t-54 -24.5t-63.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 581,
    d: "M429 116q-54 -62 -110 -94t-114 -32q-43 0 -76 17.5t-55.5 47.5t-34 69t-11.5 81q0 63 26 121t68 103t96 72t111 27q58 0 102 -33.5t63 -82.5l22 108h32l-155 -733h-34zM218 22q33 0 64.5 11.5t60 31t52.5 45.5t44 54l42 193q-2 27 -14.5 52t-32.5 44.5t-47.5 31 t-59.5 11.5q-52 0 -100 -25t-84.5 -65.5t-58.5 -92t-22 -103.5q0 -38 10.5 -72.5t30.5 -60t49 -40.5t66 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 473,
    d: "M492 677h-392l7 33h447l-496 -710h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 320,
    d: "M352 704h-243l6 26h285l-300 -388h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 583,
    d: "M237 -10q-42 0 -77 15t-59.5 42.5t-38 67.5t-13.5 90q0 98 25 190t70.5 163t109.5 114t141 43q69 0 113.5 -38.5t52.5 -104.5l-29 -16q-7 57 -46 92t-98 35q-47 0 -90 -24.5t-80.5 -71t-67 -114t-48.5 -154.5q18 35 45 63.5t59 49t67.5 32t71.5 11.5q42 0 76 -15.5 t58 -42.5t37.5 -63t13.5 -78q0 -58 -25 -110t-66 -91t-93.5 -62t-108.5 -23zM245 22q47 0 92 20t80 54t56.5 78.5t21.5 94.5q0 36 -12 68t-33 56t-50.5 37.5t-65.5 13.5q-47 0 -92 -20.5t-80.5 -54.5t-57 -79t-21.5 -94q0 -36 12 -68t33.5 -55.5t51 -37t65.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 278,
    d: "M137 487h-71l6 33h72l38 180h35l-39 -180h119l-7 -33h-118l-104 -487h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 556,
    d: "M214 -9q-42 0 -78 12t-61.5 34.5t-40 56t-14.5 76.5l29 11q0 -38 13 -67t35.5 -49t54 -30.5t68.5 -10.5q44 0 85 14t72.5 39t50 58t18.5 72q0 64 -51.5 101t-144.5 37h-33l6 31h34q116 0 179.5 45.5t63.5 124.5q0 65 -42 103t-111 38q-64 0 -119.5 -30.5t-85.5 -80.5 l-22 19q18 28 43.5 51t56.5 39.5t65 25t69 8.5q41 0 74.5 -12t57.5 -34.5t37 -53.5t13 -68q0 -70 -45 -119.5t-130 -70.5q57 -12 89 -53t32 -96q0 -48 -23 -88.5t-60.5 -70t-85.5 -46t-99 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 366,
    d: "M187 333q-21 0 -43 5.5t-40 17t-29 29.5t-11 42l22 13q0 -32 27.5 -56t79.5 -24q27 0 51.5 7t43.5 19t30 29t11 37q0 33 -33.5 52.5t-91.5 19.5h-21l5 24h21q69 0 107.5 22.5t38.5 64.5q0 32 -26.5 51.5t-68.5 19.5q-40 0 -73 -16.5t-51 -42.5l-15 19q21 30 60.5 47.5 t83.5 17.5q54 0 86.5 -26t32.5 -66q0 -39 -26.5 -65t-79.5 -37q37 -7 57.5 -30t20.5 -53q0 -27 -14 -49.5t-37.5 -38t-54 -24.5t-63.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 540,
    d: "M-13 0q11 69 34.5 120.5t57 89.5t75.5 64.5t90 46.5q42 17 87.5 33t84 40.5t63 62t24.5 96.5q0 26 -8 50t-25 42.5t-43 29.5t-63 11q-42 0 -77 -12t-63 -29t-49 -36.5t-34 -34.5l-20 20q2 3 21 23t52 42.5t78.5 41t101.5 18.5q43 0 74.5 -13t51.5 -35.5t30 -51.5t10 -61 q0 -44 -12.5 -77.5t-34 -59t-49.5 -44t-58.5 -32.5t-61.5 -25.5t-58 -22.5q-66 -27 -109 -60t-68.5 -68.5t-38 -71t-17.5 -65.5h399l-7 -32h-438v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 360,
    d: "M48 338q16 76 55 115t100 61q26 9 53.5 18t50.5 22t37.5 32t14.5 49q0 28 -21 49t-66 21q-26 0 -47 -6t-38 -15t-29.5 -19.5t-20.5 -18.5l-15 18q2 3 14 13.5t32.5 22.5t48.5 21.5t63 9.5q57 0 83 -26.5t26 -64.5q0 -34 -15.5 -57.5t-40 -39.5t-53.5 -27t-56 -20 q-38 -13 -62.5 -29.5t-39 -34.5t-21.5 -35.5t-10 -32.5h240l-5 -26h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 554,
    d: "M169 -10q-36 0 -60 10t-38.5 28t-20.5 42.5t-6 53.5q0 23 4 48.5t9 51.5l63 296h34l-63 -292q-5 -26 -8.5 -49.5t-3.5 -44.5q0 -25 5 -45.5t17 -35.5t32 -23t49 -8q35 0 70 14t66.5 37t57 53.5t41.5 63.5l71 330h34l-111 -520h-33l27 127q-21 -31 -49 -56t-59 -43 t-64 -28t-64 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 765,
    d: "M68 520h37l56 -474l248 474h35l46 -474l258 474h36l-286 -520h-34l-48 471l-248 -471h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 493,
    d: "M168 0l-114 520h36l104 -484l297 484h34l-450 -733h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 647,
    d: "M257 -10q-54 0 -93 25.5t-63.5 66t-36.5 91t-12 100.5t13 101.5t36.5 100t56.5 91.5t73 75t85 50.5t94 18.5q55 0 93.5 -25.5t63.5 -66.5t36.5 -91.5t11.5 -100.5q0 -75 -28.5 -152.5t-77.5 -140.5t-114 -103t-138 -40zM264 23q46 0 87 18.5t76 49t63.5 71t48.5 85 t30.5 89.5t10.5 86q0 48 -11 93.5t-32.5 81.5t-54.5 58t-78 22q-46 0 -87.5 -19t-76.5 -50.5t-63 -73.5t-47.5 -88t-30 -93t-10.5 -89q0 -47 10 -90.5t31 -77t54 -53.5t80 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 127,
    d: "M19 -138l17 83h32l-17 -83h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 427,
    d: "M149 -5q-36 0 -62 14.5t-42.5 37t-24 51t-7.5 57.5q0 40 17 81t47 75t70 55.5t85 21.5q36 0 61.5 -14.5t42 -38t24 -52t7.5 -56.5q0 -40 -17 -81.5t-46.5 -75t-69 -54.5t-85.5 -21zM155 21q41 0 75 20t58 50.5t37.5 66t13.5 65.5q0 25 -7 50t-21 44.5t-35.5 31.5 t-49.5 12q-41 0 -75 -20t-58.5 -50.5t-38 -66t-13.5 -66.5q0 -25 7 -49.5t21 -44t35.5 -31.5t50.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 250,
    d: "M-11 26h81l71 334q-6 -6 -18.5 -14.5t-27.5 -15.5t-30.5 -12t-27.5 -5l6 26q15 0 33 8t34 18t26.5 19t11.5 10h27l-78 -368h76l-6 -26h-183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 354,
    d: "M106 -5q-45 0 -76.5 21t-42.5 55l23 12q11 -29 38 -46t65 -17q28 0 53 9t44.5 25t31 37.5t11.5 46.5q0 20 -8 35.5t-21.5 26t-31 16t-36.5 5.5q-31 0 -61 -13t-52 -36h-26q4 9 12 27.5t18 41.5t20.5 47.5t19.5 45t15.5 35.5t7.5 19h204l-6 -27h-182l-68 -152 q23 18 50.5 27t56.5 9q51 0 83.5 -28.5t32.5 -73.5q0 -33 -15 -60t-39.5 -46.5t-56 -30.5t-64.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 384,
    d: "M133 -5q-55 0 -88.5 33t-33.5 91q0 56 15.5 105.5t43.5 86.5t66.5 58.5t84.5 21.5q42 0 71.5 -20t36.5 -55l-21 -15q-5 29 -30.5 47t-61.5 18q-58 0 -103 -48t-65 -137q21 35 61.5 56.5t83.5 21.5q54 0 87 -31.5t33 -78.5q0 -32 -15 -60t-40 -49t-57.5 -33t-67.5 -12z M140 20q28 0 54.5 10t47 27t33 39t12.5 47q0 19 -7.5 36t-21 29.5t-32.5 20t-41 7.5q-28 0 -54.5 -10t-47 -27t-33 -39.5t-12.5 -47.5q0 -38 29 -65t73 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 321,
    d: "M279 361h-242l5 27h285l-300 -388h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 384,
    d: "M117 -5q-43 0 -72 20t-37 55l22 15q5 -29 30.5 -47t61.5 -18q57 0 102.5 48t65.5 136q-22 -35 -62 -56.5t-84 -21.5q-27 0 -49 8.5t-38 23.5t-24.5 35.5t-8.5 43.5q0 31 15 59t40 49t57.5 33.5t67.5 12.5q56 0 89.5 -33.5t33.5 -91.5q0 -56 -15 -105t-43 -86t-66.5 -58.5 t-85.5 -21.5zM153 150q28 0 54.5 10t47 27t33 39.5t12.5 47.5q0 38 -28.5 65t-73.5 27q-28 0 -54.5 -10t-47 -27t-33 -39.5t-12.5 -46.5q0 -39 28.5 -66t73.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 426,
    d: "M221 337q-36 0 -61.5 14.5t-42 37.5t-24.5 51.5t-8 57.5q0 40 17 81t47 74.5t70 55t85 21.5q36 0 61.5 -14.5t42 -37.5t24 -51.5t7.5 -56.5q0 -40 -17 -81.5t-46.5 -75t-69 -55t-85.5 -21.5zM113 501q0 -26 7 -50.5t21 -43.5t35.5 -31t50.5 -12q41 0 75 20t58.5 50 t38 65.5t13.5 66.5q0 25 -7 50t-21 44.5t-35.5 31.5t-49.5 12q-42 0 -76 -20t-58.5 -50.5t-38 -66t-13.5 -66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 358,
    d: "M255 342l23 108h-220l6 25l281 255h19l-54 -254h53l-5 -26h-53l-23 -108h-27zM97 476h187l45 211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 383,
    d: "M386 488q0 -32 -15 -60t-40 -49t-58 -33t-68 -12q-55 0 -88.5 33t-33.5 91q0 56 15.5 105.5t43.5 86.5t66.5 58.5t84.5 21.5q42 0 71.5 -20t37.5 -55l-22 -15q-5 29 -30.5 47t-61.5 18q-58 0 -103 -48t-65 -137q21 36 61.5 57t83.5 21q54 0 87.5 -31.5t33.5 -78.5z M212 359q28 0 54.5 10t47 27t33 39t12.5 47q0 19 -7.5 36t-21 29.5t-32.5 20t-41 7.5q-28 0 -54.5 -10t-47 -27t-33 -39.5t-12.5 -47.5q0 -38 29 -65t73 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 372,
    d: "M364 464q0 -28 -14.5 -51.5t-38.5 -40t-55 -25.5t-64 -9q-57 0 -89.5 28.5t-32.5 67.5q0 23 10.5 42t27 33.5t37.5 25t41 16.5q-25 9 -43 27t-18 44q0 25 14 45.5t36 34t49 21t53 7.5q22 0 42 -5.5t35.5 -15.5t24.5 -25.5t9 -34.5q0 -18 -8 -33.5t-21 -28t-30.5 -21.5 t-36.5 -15q32 -11 52 -33t20 -54zM337 462q0 18 -9 32t-23 24t-32 15t-37 5q-24 0 -48.5 -7t-44.5 -20.5t-32.5 -32t-12.5 -40.5q0 -18 9 -31.5t23.5 -23t32.5 -14.5t37 -5q23 0 47.5 7t44.5 19.5t32.5 30.5t12.5 41zM153 623q0 -15 7.5 -26.5t20 -19.5t28.5 -12t32 -4 q19 0 40.5 5.5t39 16t29 26t11.5 34.5q0 15 -7.5 26.5t-20 19.5t-28.5 12t-34 4q-22 0 -43 -6t-37.5 -16.5t-27 -25.5t-10.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 384,
    d: "M96 576q0 31 15 59t40 49t57.5 33.5t67.5 12.5q56 0 89.5 -33t33.5 -91q0 -56 -15 -105.5t-43 -86.5t-66.5 -58.5t-85.5 -21.5q-42 0 -71.5 20t-37.5 55l22 15q5 -29 30.5 -47t62.5 -18q57 0 102 48t65 136q-21 -35 -61.5 -56.5t-84.5 -21.5q-54 0 -87 32t-33 79z M270 705q-28 0 -54.5 -10t-47 -27t-33 -39t-12.5 -47q0 -39 28.5 -66t73.5 -27q28 0 54.5 10t47 27t33 39.5t12.5 47.5q0 38 -28.5 65t-73.5 27z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0142",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "q.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "d.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "a.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xE1",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "d",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "a",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "four.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayExtraLightItalic);
export default __webpack_public_path__ + "static/media/Raleway-ExtraLightItalic.1a20c40cf944f266f64c63b5c6d3fb0a.svg";
export { ForwardRef as ReactComponent };